{
    "headerData1": "MyHelp",
    "headerData2": "Twój asystent AI do wsparcia IT",
    "headerMessage": "Użyj <span class='me8eon'>MyHelp</span>, aby rozwiązywać problemy IT, korzystać z przewodników krok po kroku lub zostać skierowanym do odpowiedniego kanału wsparcia IT.",
    "loginLable": "Zaloguj się",
    "logOff": "Wyloguj się",
    "logIn": "Zaloguj się",
    "userName": "Nazwa profilu",
    "switchLanguage": "Zmień język",
    "switchRole": "Zmień rolę",
    "new": "NOWE",
    "whatsnew": "Zobacz, co nowego",
    "whatsnewtt": "Dowiedz się, co nowego w MyHelp",
    "organiseTiles": "Organizuj kafelki",
    "confirm": "Potwierdź",
    "cancel": "Anuluj",
    "close": "Zamknij",
    "reset": "Resetuj",
    "continue_Tour": "Kontynuuj wycieczkę",
    "skip_Tour": "Pomiń wycieczkę",
    "save": "Zapisz",
    "submit": "Prześlij",
    "delete": "Usuń",
    "trash_bin": "Usuń",
    "edit": "Edytuj",
    "yes": "Tak",
    "no": "Nie",
    "feedbackWidget": "Twoja opinia",
    "itSupportPrompt": "Potrzebuję wsparcia IT",
    "redirectingToITSupportAgent": "Przekierowywanie do agenta wsparcia IT",
    "restoredWidgetNotice": "Z wcześniejszej rozmowy. Akcje są wyłączone; zapytaj ponownie, aby rozpocząć nowe zgłoszenie.",
    "myITsupport": "Moje wsparcie IT",
    "shareViaOutlook": "Udostępnij przez Outlook",
    "registerLable": "Aby się zarejestrować",
    "underDevelopmentMsg": "Ta strona jest w trakcie rozwoju",
    "apiFailDefaultMsg": "Coś poszło nie tak. Spróbuj ponownie później.",
    "more": "Więcej",
    "searchResult": "Wyniki wyszukiwania",
    "showAll": "Pokaż wszystko",
    "showRelevant": "Pokaż istotne",
    "assistantTabTooltip": "Asystent odpowiada na Twoje pytania, przeszukując wewnętrzne zasoby E.ON w czasie rzeczywistym. Daje jasne, łatwe do zrozumienia odpowiedzi ze źródłami, abyś mógł zaufać informacjom",
    "searchTabTooltip": "E.ON Search to tradycyjne wyszukiwanie, które pomaga szybko znaleźć informacje z różnych źródeł E.ON i własnych danych. Zapewnia najbardziej istotne wyniki i linki do źródeł",
    "landingPage": {
        "hello": "Cześć",
        "title": "jak mogę Ci pomóc?",
        "searchApps": "Aplikacje",
        "suggestions": "Sugestie"
    },
    "footer": {
        "imprint": "Impressum",
        "privacyPolicy": "Polityka prywatności",
        "termsofUse": "Warunki użytkowania",
        "contact": "Kontakt",
        "PKI": "PKI",
        "privacySettings": "Ustawienia prywatności",
        "aboutMe8EON": "O MyHelp",
        "copyrights": "Prawa autorskie treści"
    },
    "tilePage": {
        "backToSearch": "Powrót do poprzedniej strony",
        "myInboxCountSuffix": "Oczekujące"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Wszystkie",
            "leaveApptoval": "LeaveApproval",
            "timeSheet": "TimeSheet",
            "claim": "Roszczenie",
            "serviceRequest": "ServiceRequest"
        },
        "tableData": {
            "approve": "Zatwierdź",
            "reject": "Odrzuć",
            "requestId": "Identyfikator żądania",
            "description": "Opis",
            "requestedBy": "Zgłoszone przez",
            "requestedType": "Typ zgłoszenia",
            "requestedDate": "Data zgłoszenia",
            "status": "Status"
        }
    },
    "appData": {
        "time": "Śledzenie czasu",
        "meeting": "Rezerwacja sali konferencyjnej",
        "approval": "Moje zatwierdzenia",
        "pr": "Utwórz zapotrzebowanie na zakup",
        "pra": "Utwórz zaawansowane zapotrzebowanie na zakup",
        "processing": "Moja skrzynka odbiorcza",
        "hr": "Portal HR",
        "hrLabel": "Portal HR",
        "concur": "Concur Rezerwacja podróży i wydatki",
        "password": "Resetowanie hasła SAP",
        "ariba": "Ariba - Klasyczny i Klasyczny+",
        "itresources": "Zasoby IT",
        "myassets": "Moje aktywa",
        "order": "Zamówienie",
        "incident": "Incydenty",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Portal powiadomień",
        "zuko": "Zuko",
        "eon_brand": "Przestrzeń marki EON",
        "pki": "Portal PKI",
        "mail": "Mail DL",
        "journey": "Podróże/Wydarzenia",
        "mygenius": "MyGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Akta osobowe - Cyfrowe akta osobowe - DPF",
        "corpsac": "Korporacyjny SAC",
        "corpportal": "Portal korporacyjny",
        "redwood": "Automatyzacja finansowa Redwood",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "Portal SoD SAP",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Bankowość: Zarządzanie kontem bankowym (EBAM)",
        "egs": "E.ON Rozwiązanie gwarancyjne",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Zarządzanie ryzykiem",
        "slido": "Slido",
        "insightslibrary": "Biblioteka wglądów",
        "getabstract": "getAbstract",
        "mypotential": "Osiąganie mojego potencjału",
        "dsesoftware": "Oprogramowanie DSE",
        "whistleblowing": "Rozwiązanie E.ON Whistleblowing",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Zgłoszenie incydentu",
        "cateringportal": "Plan posiłków",
        "westnetzregelwerke": "Regulacje Westnetz",
        "werbemittel": "Materiały reklamowe",
        "westenergie_brand": "Portal zarządzania marką",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM i ERM",
        "smartguide": "Smart Guide",
        "tagetiksac": "Tagetik SAC",
        "myit": "moje IT",
        "timehover": "Dzięki aplikacji CATS możesz łatwo śledzić i zarządzać swoimi godzinami pracy i aktywnościami, mając wszystkie istotne informacje i funkcje w jednym miejscu.",
        "meetinghover": "Dzięki Gingco, naszemu narzędziu do rezerwacji sal, możesz łatwo zarządzać i planować swoje sale konferencyjne i zasoby, zapewniając efektywne wykorzystanie i dostępność, wszystko w jednym miejscu.",
        "approvalhover": "Dzięki myInbox możesz łatwo i efektywnie zatwierdzać faktury, mając wszystkie istotne informacje i działania w jednym miejscu.",
        "prhover": "Tutaj znajdziesz wszystkie istotne funkcje do zamawiania towarów i usług. Jest to również znane jako BANF (niem. zapotrzebowanie na zakup)",
        "prahover": "Tutaj znajdziesz wszystkie istotne funkcje do zamawiania towarów i usług. Jest to również znane jako BANF (niem. zapotrzebowanie na zakup)",
        "processinghover": "Dzięki myInbox możesz łatwo i efektywnie zatwierdzać faktury, mając wszystkie istotne informacje i działania w jednym miejscu.",
        "hrhover": "Dzięki myHR możesz wygodnie uzyskać dostęp i zarządzać swoimi informacjami i zadaniami związanymi z HR w jednym miejscu.",
        "concurhover": "Dzięki Concur możesz łatwo zarządzać i przesyłać swoje raporty podróży i wydatków, mając wszystkie istotne informacje i działania w jednym miejscu.",
        "passwordhover": "Dzięki tej kafelce możesz łatwo zresetować hasła dostępu do swoich systemów SAP.",
        "aribahover": "Dzięki SAP Ariba możesz łatwo zarządzać swoimi procesami zakupowymi, mając wszystkie istotne informacje i narzędzia w jednym miejscu.",
        "itresourceshover": "Zasoby IT",
        "myassetshover": "Moje aktywa",
        "orderhover": "Zamówienie",
        "incidenthover": "Incydenty",
        "beelinehover": "Dzięki Beeline możesz efektywnie zarządzać swoją tymczasową siłą roboczą i usprawniać procesy zatrudniania, uzyskując dostęp do wszystkich niezbędnych narzędzi i informacji w jednym miejscu.",
        "prismahover": "PRISMA oznacza Platformę do raportowania incydentów i zarządzania zrównoważonym rozwojem oraz audytów. Platforma wspiera dział HSE E.ON w jego misji, aby E.ON był miejscem świadomym zdrowia, bezpiecznym i dbającym o środowisko. PRISMA jest dostępna zarówno przez internet, jak i jako aplikacja.",
        "gertrudhover": "Gertrud",
        "notificationhover": "Portal powiadomień",
        "zukohover": "Zuko",
        "eon_brandhover": "Przestrzeń marki EON",
        "pkihover": "Portal PKI",
        "mailhover": "Mail DL",
        "journeyhover": "Podróże/Wydarzenia",
        "mygeniushover": "MyGenius",
        "ideeonhover": "Idee.on to platforma, która umożliwia pracownikom zgłaszanie i ocenianie pomysłów oraz sugestii dotyczących zarządzania pomysłami. Została zaprojektowana, aby ułatwić ciągły proces doskonalenia we wszystkich obszarach firmy.",
        "ideenethover": "IdeeNet to oprogramowanie do zarządzania pomysłami w najprawdziwszym tego słowa znaczeniu. Różnorodne pomysły, takie jak &#10;&bull; Centralizowane BVW, zdecentralizowane BVW i mieszane formy &#10;&bull; Kręgi jakości i CIP &#10;&bull; Raporty o błędach i skargi &#10;&bull; Wynalazki pracownicze &#10;mogą być efektywnie obsługiwane za pomocą tego oprogramowania, w zjednoczonej bazie danych pomysłów, ale przy użyciu różnych strategii.",
        "dpfhover": "Twoje akta osobowe zawierają znacznie więcej dokumentów niż te stale wyświetlane w MyHR! &#10;Złóż wniosek HR i poproś o dostęp do całych swoich akt osobowych! Po profesjonalnej weryfikacji zostaną one udostępnione za pomocą bezpośredniego linku.",
        "corpsachover": "SAC to potężne narzędzie wizualizacyjne z zaawansowanymi możliwościami planowania",
        "corpportalhover": "Portal korporacyjny to centralna wewnętrzna platforma aplikacyjna z integracją aplikacji opartą na rolach i rozwojem dla dostępu Single-Sign-On do backendów SAP.",
        "redwoodhover": "Redwood FA jest używany do planowania skonsolidowanych sprawozdań finansowych i automatyzacji poszczególnych działań",
        "eamsap200hover": "Zarządzanie zasobami przedsiębiorstwa &#10;Środowisko dla samodzielnych rozwiązań opartych na platformie technologii biznesowej (BTP) od SAP (dawniej SAP Cloud Platform) - konto EAM dla kokpitów sieciowych, w tym instancje chmurowe: produkcja, QA (zapewnienie jakości), rozwój i staging.",
        "eamsap100hover": "Zarządzanie zasobami przedsiębiorstwa &#10;Środowisko dla samodzielnych rozwiązań opartych na platformie technologii biznesowej (BTP) od SAP (dawniej SAP Cloud Platform) - konto EAM dla kokpitów sieciowych, w tym instancje chmurowe: produkcja, QA (zapewnienie jakości), rozwój i staging.",
        "sodsaphover": "Portal SOD jest zaprojektowany do usprawnienia i zdigitalizowania zarządzania segregacją obowiązków (SOD). Dzięki cyfryzacji identyfikacji, monitorowania i rozwiązywania konfliktów SOD, zapewnia zgodność z normami regulacyjnymi i zwiększa bezpieczeństwo organizacyjne. To narzędzie jest niezbędne do utrzymania solidnego systemu kontroli wewnętrznej i ochrony operacji biznesowych.",
        "videonhover": "Aplikacja do rezerwacji usług z studia wideo/TV na Brüsseler Platz na produkcję wideo/TV lub wydarzenie streamingowe.",
        "alteryxhover": "Platforma analizy danych używana do tworzenia aplikacji analitycznych i przepływów pracy. Pozwala użytkownikom zarządzać i udostępniać aplikacje analityczne, uruchamiać przepływy pracy oraz uzyskiwać dostęp i raportować wyniki w środowisku serwerowym.",
        "ebamhover": "Elektroniczne zarządzanie kontem bankowym",
        "egshover": "E.ON SE przejmuje poręczenia i gwarancje dla BU grupy wobec zewnętrznych pożyczkodawców",
        "epsnexthover": "Centralne narzędzie elektronicznej bankowości dla wszystkich MU/Bus",
        "fisquantumhover": "Rozwiązanie FIS Quantum Treasury Management jest zaprojektowane, aby zwiększyć efektywność i skuteczność operacji skarbowych Twojej organizacji. Ta platforma natywna dla chmury zapewnia widoczność w czasie rzeczywistym w zakresie gotówki i płynności, umożliwiając lepsze podejmowanie decyzji dotyczących zarządzania kapitałem i ryzykiem. Dzięki zaawansowanym funkcjom zarządzania długiem, inwestycjami i zgodnością, pomaga usprawnić przepływy pracy i poprawić wyniki finansowe.",
        "rmshover": "System zarządzania ryzykiem w całej grupie E.ON (przetwarzanie aplikacji kredytowych i system zarządzania ryzykiem kredytowym)",
        "slidohover": "Slido to interaktywna platforma zaprojektowana w celu zwiększenia zaangażowania publiczności i zbierania wglądów podczas wydarzeń na żywo lub wirtualnych, spotkań i prezentacji. Umożliwia użytkownikom przeprowadzanie ankiet na żywo, sesji Q&A i quizów w czasie rzeczywistym, tworząc dynamiczne i uczestniczące doświadczenie dla publiczności.",
        "insightslibraryhover": "Biblioteka wglądów to centralne repozytorium wiedzy E.ON dotyczące wglądów klientów i rynku w ramach działalności związanej z rozwiązaniami dla klientów.",
        "getabstracthover": "getAbstract to ogólnogrupowa biblioteka online E.ON, dostarczana przez getAbstract, z streszczeniami książek, artykułami i innymi formatami edukacyjnymi, które obejmują wszystkie umiejętności biznesowe (umiejętności miękkie i funkcjonalne)",
        "mypotentialhover": "System dla pracowników i menedżerów w Wielkiej Brytanii do rejestrowania ich wyników, celów i przeglądów.",
        "dsesoftwarehover": "Szkolenie i oceny ekranów wyświetlających dla zdrowia i bezpieczeństwa",
        "whistleblowinghover": "Narzędzie Whistleblowing pozwala każdemu, kto dostarcza informacje, zgłosić raport anonimowo. Można to zrobić za pomocą formularza internetowego, e-maila lub telefonu. Podczas rozmowy głos zostanie zniekształcony.",
        "maqsimahover": "Zarządzanie ocenami ryzyka, instrukcjami operacyjnymi, substancjami niebezpiecznymi &#10;Maqsima pomaga szybko i łatwo śledzić wszystkie istotne oceny ryzyka i instrukcje operacyjne oraz utrzymywać je na bieżąco w inteligentny sposób.",
        "digitalrulebookhover": "Paula Policy to oparty na sztucznej inteligencji asystent ds. polityk korporacyjnych E.ON, który zapewnia pracownikom szybki i łatwy dostęp do People Guidelines, Function Policies oraz Kodeksu Postępowania. Udziela spójnych i rzetelnych odpowiedzi, czyniąc złożone polityki łatwymi do zrozumienia i dostępnymi dla każdego.",
        "oneERPhover": "Portal one.ERP to centralna platforma w ramach grupy Westenergie, która konsoliduje różne funkcje i informacje związane z ERP. Służy jako centrum informacji i kontroli dla użytkowników ERP i menedżerów IT i jest częścią ogólnej strategii digitalizacji grupy.",
        "Perseushover": "Portal bezpieczeństwa to centralny punkt dostępu do zgłaszania incydentów związanych z bezpieczeństwem w organizacjach Westenergie i Westnetz. Jest często używany w połączeniu z wewnętrznym systemem zgłaszania Perseus, który jest specjalnie zaprojektowany do obsługi incydentów takich jak utrata urządzenia, kradzież lub naruszenia ochrony danych.",
        "cateringportalhover": "Portal eon.cateringportal.io to cyfrowa platforma dla aplikacji E.ON Canteen. Dostarcza plany posiłków, szczegóły lokalizacji i inne usługi cateringowe dla pracowników E.ON.",
        "westnetzregelwerkehover": "Ten portal służy jako centralne źródło dla regulacji technicznych i dokumentacji związanej z eksploatacją i zarządzaniem sieciami elektrycznymi i gazowymi. Zapewnia dostępność wszystkich istotnych wytycznych, standardów i specyfikacji technicznych wymaganych do bezpiecznej i efektywnej eksploatacji sieci.",
        "werbemittelhover": "Sklep z materiałami promocyjnymi Westenergie to platforma online, przez którą pracownicy i upoważnieni partnerzy grupy Westenergie mogą zamawiać materiały promocyjne i komunikacyjne.",
        "westenergie_brandhover": "Baza danych obrazów Westenergie oraz elementy marki i wytyczne projektowe grupy Westenergie. Dostęp do wszystkich komponentów naszej marki, aby tworzyć chwile Westenergie. Od systemu zarządzania marką z wszystkimi ważnymi wytycznymi dotyczącymi użycia elementów marki, takich jak logo, symbole i nasza skrzynka czatu, po bibliotekę mediów z licznymi obrazami dla wszystkich wariantów projektowych.",
        "compasshover": "Compass to ogólnogrupowa wewnętrzna platforma komunikacyjna dla wiadomości i treści E.ON, sieci i wymiany pracowników.",
        "gradarhover": "To narzędzie jest używane do rozpoczęcia procesu oceny stanowisk kierowniczych.",
        "beqomhover": "Beqom jest używany w całej grupie do zarządzania i komunikacji planów motywacyjnych E.ON na długi okres. Jest używany przez HR, księgowość, podatki i kierownictwo. Oprócz spraw związanych z planami motywacyjnymi na długi okres, beqom może być również używany do tworzenia list płac i premii oraz oświadczeń o całkowitym wynagrodzeniu.",
        "kychover": "Dzięki narzędziu Know-Your-Counterpart (KYC) możesz sprawdzać kontrahentów zgodnie ze standardowymi politykami (np.: PG-03).",
        "talentryhover": "Skorzystaj z tej okazji, aby podzielić się naszymi aktualnymi ofertami pracy z utalentowanymi osobami w Twojej sieci – osobami, które chcą kształtować przyszłość swoją energią.",
        "samhover": "Możesz przeprowadzać obowiązkowe szkolenia z zakresu bezpieczeństwa za pomocą tego narzędzia.",
        "enormhover": "e-NORM to potężne oprogramowanie do zarządzania, udostępniania i aktualizacji danych związanych z zapewnieniem jakości lub dokumentami standardowymi, a także do łączenia powiązanych plików.",
        "redonlinehover": "Monitor zgodności Red-on-line (ROL) upraszcza zarządzanie zgodnością regulacyjną, dostarczając aktualizacje w czasie rzeczywistym dotyczące regulacji środowiskowych, zdrowotnych i bezpieczeństwa (EHS). Oferuje monitorowanie i pulpity, które pomagają proaktywnie rozwiązywać problemy związane z zgodnością. To narzędzie jest niezbędne do utrzymania bezpiecznego i zgodnego miejsca pracy, zmniejszenia ryzyka i poprawy efektywności operacyjnej.",
        "tagetikcpmhover": "Aplikacja Tagetik Corporate Performance Management (CPM) do budżetowania i planowania, konsolidacji, ryzyka i raportowania zarządczego (wprowadzona przez Finance Excellence) E.ON SE (Grupowe raportowanie). Główne procesy to kwartalne zamknięcia mające bardzo duży wpływ zewnętrzny ze względu na twardy termin dla komunikacji na rynku kapitałowym.",
        "tagetikcpmermhover": "Aplikacja Tagetik Corporate Performance Management (CPM) i Enterprise Risk Management (ERM) do budżetowania i planowania, konsolidacji, ryzyka i raportowania zarządczego (wprowadzona przez Finance Excellence) E.ON SE (Grupowe raportowanie). Główne procesy to kwartalne zamknięcia mające bardzo duży wpływ zewnętrzny ze względu na twardy termin dla komunikacji na rynku kapitałowym.",
        "smartguidehover": "Hub Smart Guide to wiki, które ma być redakcyjnie utrzymywane przez kilku kolegów, aby dostarczać polityki dla około 4000 użytkowników w obszarach IFRS, Controlling, HGB i ESG.",
        "tagetiksachover": "Dashboard Tagetik. Tagetik to aplikacja do budżetowania i planowania, konsolidacji, ryzyka i raportowania zarządczego (wprowadzona przez Finance Excellence) E.ON SE (Grupowe raportowanie). Główne procesy to kwartalne zamknięcia mające bardzo duży wpływ zewnętrzny ze względu na twardy termin dla komunikacji na rynku kapitałowym.",
        "myithover": "Twój punkt odniesienia dla wszystkiego związanego z IT: opcje wsparcia, przydatne linki, społeczności i najnowsze wiadomości, które musisz znać.",
        "servicehub": "Centrum usług",
        "servicehubhover": "Dzięki EON Service Hub możesz łatwo zamawiać nowe oprogramowanie i sprzęt, w tym laptopy i monitory, oraz uzyskać wsparcie IT, zgłaszając problemy lub rozmawiając z Globalnym Biurem Obsługi, wszystko w jednym miejscu.",
        "SailPoint": "Przegląd zarządzania tożsamością",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Process Design",
        "Celonis": "Celonis Process Mining",
        "Carsync": "Carsync Zarządzanie flotą",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "Dzięki SailPoint można centralnie zarządzać prawami dostępu i tożsamościami.",
        "P29hover": "Dzięki SAP EIC można efektywnie przetwarzać i dokumentować zgłoszenia i zapytania klientów. Aplikacja wspiera integrację z ECG i zapewnia centralny interfejs do obsługi zgłoszeń.",
        "P83hover": "Dzięki SAP EIC można efektywnie przetwarzać i dokumentować zgłoszenia i zapytania klientów. Aplikacja wspiera integrację z ECG i zapewnia centralny interfejs do obsługi zgłoszeń.",
        "BIChover": "Dzięki BIC Cloud można modelować, analizować i optymalizować procesy biznesowe.",
        "Celonishover": "Process Mining: Analiza rzeczywistych procesów na podstawie dzienników zdarzeń z ERP, CRM i innych systemów. Zarządzanie wykonaniem: Automatyzacja przepływów pracy i rekomendacje działań. Optymalizacja procesów: Identyfikacja nieefektywności, np. w procesach Purchase-to-Pay lub Order-to-Cash. Integracja: Połączenie z systemami takimi jak SAP, Salesforce, Oracle itp.",
        "Carsynchover": "Dzięki Carsync można efektywnie zarządzać samochodami służbowymi i flotami pojazdów, dokumentować podróże i optymalizować koszty.",
        "ISUSpacehover": "Dzięki ISU/Space można łatwo rezerwować i zarządzać miejscami pracy i salami konferencyjnymi.",
        "GNIShover": "Dzięki GNIS można efektywnie zarządzać i wymieniać dane główne i dane sieciowe dla komunikacji rynkowej (EDI).",
        "ecount_EDIhover": "Dzięki eccount można zarządzać, wymieniać i analizować dane główne i dane sieciowe związane z EDI.",
        "SAP_Datasphere_EDIhover": "Dzięki SAP Datasphere można integrować, modelować i udostępniać dane z różnych źródeł do analiz i decyzji biznesowych. Platforma wspiera samoobsługę, zarządzanie danymi i dostęp do danych w czasie rzeczywistym.",
        "CFLP": "CFLP",
        "corporateWorkspace": "Corporate Workspace",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "CFLPhover": "Centralny punkt dostępu do systemów SAP i usług chmurowych.",
        "corporateWorkspacehover": "SAP Build Work Zone, Advanced Edition umożliwia tworzenie cyfrowych środowisk pracy w celu zwiększenia produktywności i zaangażowania użytkowników. Centralizuje dostęp do odpowiednich aplikacji biznesowych, procesów, informacji i komunikacji w jednym punkcie dostępu, dostępnym z dowolnego urządzenia.",
        "SAPWebLaunchpadhover": "SAP Web Launchpad zapewnia dostęp do systemów SAP przez przeglądarkę z wykorzystaniem Fiori i WebGUI. Konfigurowalna strona startowa, w tym ulubione, umożliwia szybki dostęp do systemów SAP i klientów.",
        "PKI_Semnatura_Digitala_6781": "PKI - Podpis cyfrowy",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Ocena pracowników EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Zgłoszenia administracji budynkami EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Delegacje EER",
        "Users_Access_EER_5369": "Dostęp użytkowników EER",
        "Planificare_Concedii_EER_8588": "Planowanie urlopów EER",
        "Pontaje_si_Telemunca_EER_7087": "Ewidencja czasu pracy i praca zdalna EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Premia pracownicza",
        "GRC_Request_5510": "Wniosek GRC",
        "iPEN_Portal_3047": "Portal iPEN",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "Portal IT (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "Zgłoś incydent bezpieczeństwa IT VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "Zgłoś incydent HSE VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Menu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "Formularz zgłoszeniowy IT VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Zaświadczenia i inne aplikacje HR (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Rozliczenia kartą firmową (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Dokumenty delegacji (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "Resetuj token",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Portal oceny pracowników EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Portal zgłoszeń administracji budynkami EER",
        "MRBS_EER_8445hover": "Rezerwacja sali konferencyjnej EER",
        "Delegatii_EER_1137hover": "Portal delegacji EER",
        "Users_Access_EER_5369hover": "Formularz dostępu użytkowników EER",
        "Planificare_Concedii_EER_8588hover": "Planowanie urlopów EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Ewidencja czasu pracy i praca zdalna EER",
        "BOT_6231hover": "Refundacja bonów wypoczynkowych i leczniczych",
        "Bonusare_personal_6879hover": "Premia pracownicza",
        "GRC_Request_5510hover": "GRC oznacza Governance & Risk Compliance Access Control i jest narzędziem workflow SAP do automatycznego wnioskowania, zatwierdzania i przypisywania uprawnień użytkowników w systemach SAP.",
        "iPEN_Portal_3047hover": "Information Platform of Energy Networks, w skrócie iPEN, zapewnia, że dane jednostek regionalnych mogą być agregowane i centralnie udostępniane. Istniejące i nowo opracowane inteligentne rozwiązania są podłączane do platformy. Dzięki temu mogą być wdrażane w całej społeczności sieciowej w sposób szybki, elastyczny i efektywny kosztowo. iPEN jest zatem kluczowym elementem umożliwiającym skalowanie inteligentnych rozwiązań.",
        "YourVoiceEON_0693hover": "Platforma PEAKON wysyła raz w tygodniu około 4-5 pytań dotyczących Twojego samopoczucia i bieżącej sytuacji zawodowej. Możesz ocenić pytania (od 0 do 10), skomentować je lub pominąć. Odpowiedź na te kilka pytań zajmuje tylko około 1-2 minut.",
        "ITPortal_5530hover": "Portal usług IT firmy Süwag",
        "Transf4m_Ticket_Tool_6635hover": "Narzędzie Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Menu",
        "Ariba_8690hover": "Portal zakupowy",
        "DiSch_20_0545hover": "To jest moje cyfrowe miejsce pracy",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Confluence firmy Süwag",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Raportowanie czasu",
        "CTP_2407hover": "CTP (Czas to pieniądz)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Business Processing support with jira",
        "Qmatic_PL_CS_3195hover": "Application to manage customer flow(queues) in POS",
        "Qmatic_PL_EN_3118hover": "Application to manage customer flow(queues) in POS",
        "CCM_Inspire_7264hover": "Scentralizowana platforma E.ON do zarządzania komunikacją z klientami (CCM), oparta na Quadient Inspire, do tworzenia i dostarczania komunikacji z klientami.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "To jest nasz system rejestracji czasu pracy",
        "Atoss_VSEGruppe_4374hover": "To jest nasz system rejestracji czasu pracy",
        "AWS_Access_Portal_1318hover": "Dostęp do kont AWS",
        "eDIVA_5372hover": "Zarządzanie użytkownikami ANF",
        "G2G_VSEGruppe_6518hover": "System GIS VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Dostęp do chmury AWS VSE-Gruppe",
        "Qualys_Security_4331hover": "Monitorowanie ryzyka przedsiębiorstwa",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "Zgłoś incydent bezpieczeństwa IT VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "Zgłoś incydent HSE VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Menu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "Formularz zgłoszeniowy IT VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Instrukcje",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Celem tej aplikacji jest umożliwienie każdemu użytkownikowi pobierania różnych zaświadczeń w maksymalnie trzech kliknięciach. Aplikacja oferuje także funkcje dla administratorów HR i koordynatorów zespołów, którzy mogą pobierać zaświadczenia dla podległych im współpracowników. Pracownicy mogą również obliczyć staż pracy i świadczenie emerytalne oraz zamawiać inne dokumenty w dziale HR.",
        "Deconturi_card_companie_RO_CS_5333hover": "Posiadacze kart firmowych mogą łatwo składać rozliczenia wydatków w tej aplikacji, bez wysyłania paragonów e-mailem lub pocztą ani proszenia o zatwierdzenie e-mailem. Cały proces odbywa się na tej platformie.",
        "Documente_delegatii_RO_CS_5332hover": "Aplikacja do zarządzania delegacjami pozwala użytkownikom dodawać dokumenty do własnych delegacji oraz delegacji podwładnych. Administratorzy HR mogą zbiorczo przeglądać, filtrować i zamykać dokumenty, a także zamawiać dodatkowe dokumenty za pomocą automatycznie wysyłanych wiadomości e-mail.",
        "SAP_ISU_CS_RO_8555hover": "Usługa obejmuje działania związane z systemami SAP IS-U x7G używanymi przez E.ON RO CS.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Odnów / Zresetuj token",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Portal oceny pracowników EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Portal zgłoszeń administracji budynkami EER",
            "MRBS_EER_8445subTitle": "Rezerwacja sali konferencyjnej EER",
            "Delegatii_EER_1137subTitle": "Portal delegacji EER",
            "Users_Access_EER_5369subTitle": "Formularz dostępu użytkowników EER",
            "Planificare_Concedii_EER_8588subTitle": "Planowanie urlopów EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Ewidencja czasu pracy i praca zdalna EER",
            "BOT_6231subTitle": "Refundacja bonów wypoczynkowych i leczniczych",
            "Bonusare_personal_6879subTitle": "Premia pracownicza",
            "GRC_Request_5510SubTitle": "Wniosek GRC",
            "iPEN_Portal_3047SubTitle": "Platforma informacyjna sieci energetycznych",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Rezerwacja stanowisk pracy",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Portal zakupowy",
            "DiSch_20_0545SubTitle": "Cyfrowe miejsce pracy",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Śledzenie aktywności biznesowej",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Przetwarzanie procesów biznesowych",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Platforma",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA Zarządzanie użytkownikami ANF -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "Zgłoś incydent bezpieczeństwa IT VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "Zgłoś incydent HSE VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Menu VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "Formularz zgłoszeniowy IT VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Zaświadczenia i inne aplikacje HR (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Rozliczenia kartą firmową (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Dokumenty delegacji (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Centralny Fiori Launchpad",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Linki do systemów SAP",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "Systemy SAP",
            "aribaSubTitle": "Przegląd PO",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "Zamów usługi IT",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "Zatrudnienie zewnętrzne",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Przygotowanie spotkań zarządu",
            "notificationSubTitle": "Usługi obiektowe",
            "zukoSubTitle": "Organizacja przeprowadzki biura",
            "eon_brandSubTitle": "to na nas",
            "pkiSubTitle": "Zarządzanie certyfikatami",
            "mailSubTitle": "Utrzymanie",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Cyfrowa platforma edukacyjna",
            "ideeonSubTitle": "Zarządzanie pomysłami",
            "ideenetSubTitle": "Zarządzanie pomysłami",
            "dpfSubTitle": "Cyfrowe akta osobowe",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Portal korporacyjny",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "Portal SoD",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Repozytorium wiedzy",
            "getabstractSubTitle": "Biblioteka online",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "Rozwiązanie E.ON Whistleblowing",
            "maqsimaSubTitle": "Zarządzanie ocenami ryzyka",
            "digitalrulebookSubTitle": "Wytyczne grupy",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Sklep z materiałami promocyjnymi",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Ogólnogrupowa platforma komunikacji wewnętrznej",
            "gradarSubTitle": "Ocena stanowisk i wynagrodzeń",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Sprawdzenie zgodności kontrahenta",
            "talentrySubTitle": "Program poleceń pracy",
            "samSubTitle": "Szkolenie z zakresu bezpieczeństwa @E.On",
            "enormSubTitle": "Monitor zgodności",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM i ERM",
            "smartguideSubTitle": "Smart Guide Hub (Wiki księgowe)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Centrum usług",
            "myitSubTitle": "Wsparcie IT i wiadomości",
            "SailPointSubTitle": "Przegląd zarządzania tożsamością i dostępem",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Process Mining",
            "CarsyncSubTitle": "Zarządzanie flotą",
            "ISUSpaceSubTitle": "Zarządzanie miejscami pracy i salami",
            "GNISSubTitle": "Zarządzanie danymi głównymi EDI",
            "ecount_EDISubTitle": "Zarządzanie danymi EDI",
            "SAP_Datasphere_EDISubTitle": "Integracja danych i Business Data Fabric",
            "ukhrSubTitle": "UK HR App"
        },
        "ukhr": "UK HR App",
        "ukhrhover": "Twoje jedno miejsce na wszystko związane z HR w Wielkiej Brytanii. Od odcinków wypłat po rezerwację urlopów i wszystko pomiędzy. Rozpocznij z naszymi przewodnikami dla pracowników i menedżerów lub przeszukaj wszystkie zasoby HR poniżej."
    },
    "searchPage": {
        "searchPlaceholder": "Szukaj...",
        "searchApps": "Szukaj tutaj...",
        "relatedApps": "Aplikacje",
        "viewMoreApps": "Więcej",
        "removeAppTooltip": "Usuń z pulpitu",
        "addAppTooltip": "Dodaj do pulpitu",
        "addedAppTooltip": "Dodano do pulpitu"
    },
    "pwaText": {
        "header": "Zainstaluj tę aplikację na ekranie głównym!",
        "button": "Zainstaluj aplikację",
        "iphoneHeader": "Aby zainstalować tę aplikację na iPhone",
        "inst1": "Dotknij przycisku <b>Udostępnij</b> w Safari.",
        "inst2": "Przewiń w dół i wybierz <b>\"Dodaj do ekranu głównego\".</b>",
        "inst3": "Dotknij <b>Dodaj</b> w prawym górnym rogu."
    },
    "filterPage": {
        "filterMenu": {
            "backBtn": "Powrót do poprzedniej strony",
            "disclaimer": "Niektóre wyniki mogą nie być w pełni istotne. Proszę dokładnie przejrzeć.",
            "loading": "Ładowanie",
            "app": "Aplikacje",
            "gitlab": "Gitlab",
            "apps": "Aplikacje",
            "all": "Wszystko",
            "m365": "Moje pliki",
            "jql": "jql",
            "people": "Ludzie",
            "emails": "Moje e-maile",
            "teams": "Zespoły",
            "community": "Społeczność",
            "pages": "Strony",
            "users": "Użytkownicy",
            "noData": "Nie znaleźliśmy żadnych wyników dla",
            "noMoreData": "Nie znaleziono dalszych wyników dla Twojego zapytania!",
            "filterHeading": "Filtry",
            "reset": "Resetuj filtry",
            "refineResults": "Doprecyzuj wyniki",
            "card_languages": "Języki",
            "ecl_source_name": "Źródło",
            "standard_card_type": "Typ",
            "mimeType": "Typ",
            "datasources": "Źródła danych",
            "lookingFor": "Szukam",
            "timeRange": "Zakres czasu",
            "department": "Dział",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "Moje zamówienie IT",
            "aiAssistant": "Pomoc",
            "space": "Przestrzeń",
            "time": "Czas",
            "priority": "Priorytet",
            "status": "Status",
            "compass": "Kompas",
            "contentType": "Kategoria",
            "kb_articles": "Wsparcie IT",
            "officeBuddy": "Baza wiedzy E.ON",
            "key": "Projekt",
            "enterSearchTerm": "Wpisz swoje słowo kluczowe i dopracuj wyniki.",
            "categoryTags": "Kategoria",
            "companyTags": "Obszar biznesowy",
            "searchIn": "Szukaj w"
        },
        "searchResult": {
            "source": "Źródło",
            "business": "Biznes",
            "mobile": "Mobilny",
            "type": "Typ",
            "duration": "Czas trwania",
            "category": "Kategoria",
            "deliveryTime": "Czas dostawy",
            "availableLanguages": "Dostępne języki",
            "status": "Status",
            "lastUpdate": "Ostatnia aktualizacja",
            "lastUpdated": "Ostatnia aktualizacja",
            "createdOn": "Utworzono",
            "createdBy": "Utworzone przez",
            "company": "Firma",
            "department": "Dział",
            "job_title": "Stanowisko",
            "office_location": "Lokalizacja biura",
            "email": "E-mail",
            "preview": "Podgląd",
            "viewEmail": "Zobacz e-mail"
        },
        "timeRangeOptions": {
            "All": "Wszystko",
            "yesterday": "1 dzień",
            "lastWeek": "7 dni",
            "lastMonth": "1 miesiąc",
            "6 Months": "6 miesięcy",
            "lastYear": "1 rok"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "moje zamówienie IT",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Baza wiedzy",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Inne"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Wszystkie obszary biznesowe"
        },
        "searchOptionsHover": "Pokazuje treści z Twojego obszaru biznesowego, treści z grupy E.ON lub treści z innych obszarów biznesowych."
    },
    "chatBot": {
        "dislikeDialog": {
            "title": "Podziel się opinią",
            "irrelevant": "Odpowiedź nie była trafna",
            "incorrect": "Informacje były nieprawidłowe",
            "detail": "Odpowiedź nie była wystarczająco szczegółowa",
            "other": "Inne",
            "comments": "Dodatkowe komentarze",
            "placeholder": "Powiedz nam więcej o swojej opinii (opcjonalnie)",
            "later": "Może później",
            "submit": "Wyślij opinię",
            "error": "Nie udało się wysłać opinii. Spróbuj ponownie."
        },
        "chatIcon": "ChatBot",
        "sourceName": "Źródło",
        "searchBack": "Powrót do poprzedniej strony",
        "welcomeMessage": "Zaproszenie do czatu",
        "chatbotPlaceholder": "Wpisz tutaj...",
        "sendbtn": "Wyślij",
        "cancelBtn": "Anuluj",
        "showMore": "Pokaż więcej",
        "showMoreTooltip": "Pokaż pełną odpowiedź",
        "showLess": "Pokaż mniej",
        "showLessTooltip": "Zminimalizuj pełną odpowiedź",
        "continueAssistance": "Kontynuuj w Pomocy",
        "continueAssistanceTooltip": "Kontynuuj w Pomocy, aby zadać dodatkowe pytania",
        "feedbackTitle": "Czy to było pomocne?",
        "feedbackThumbsUpLabel": "Tak, pomogło",
        "feedbackThumbsDownLabel": "Wciąż potrzebuję pomocy?",
        "feedbackPrompt": "Podziel się swoją opinią tutaj",
        "askMe": "Zadaj swoje pytania",
        "imageUpload": "Prześlij obraz",
        "uploadImageTooltip": "Prześlij obraz i zadaj pytanie.",
        "uploadImageFormat": "Obsługiwany format: JPG/PNG",
        "uploadImageProcessing": "Przetwarzanie obrazu...",
        "uploadImageQuestions": "Sugerowane pytania:",
        "card": {
            "selfService": "Samodzielna obsługa",
            "efficiency": "Efektywność",
            "ngService": "Usługa nowej generacji"
        },
        "disclaimerText": "Pamiętaj, że wszystkie odpowiedzi są generowane przez AI i mogą zawierać błędy.",
        "selfServiceTitle": "Wsparcie IT",
        "selfServiceContent": "Wsparcie samodzielnej obsługi z AI dla szybkiego rozwiązywania incydentów",
        "knowledgeBaseTitle": "Baza wiedzy",
        "knowledgeBaseContent": "Poprawa doświadczenia pracowników poprzez informacje",
        "internetSearchTitle": "Ogólne pytania",
        "wentWell": "Co poszło dobrze? (opcjonalnie)",
        "wentWrong": "Co poszło źle?",
        "privacyMsg": "Szanujemy prywatność i zapewniamy, że opinie będą traktowane poufnie.",
        "appreciateService": "Doceniamy Twoją pomoc w poprawie naszych usług.",
        "feedbackMessage": "Dziękujemy za Twoją opinię!",
        "relevantSearches": "Najbardziej trafne wyszukiwania",
        "aiAssitanceSuggestion": "Możesz zadać swoje pytania AI Pomocy, używając poniższego pola wejściowego",
        "aiActionMsg": "Wygląda na to, że Twoje wewnętrzne miejsce jest pełne. Mogę pomóc Ci rozwiązać problem z instalacją, automatycznie czyszcząc tymczasowe pliki i opróżniając kosz. Czy chcesz, abym automatycznie wyczyścił?",
        "aiActionPrimaryBtn": "Wyczyść automatycznie",
        "aiActionSecondaryBtn": "Nie czyść automatycznie",
        "aiActionSuccess": "Twoje miejsce zostało wyczyszczone.",
        "aiActionFailed": "Coś poszło nie tak. Spróbuj ponownie później. Lub spróbuj ręcznie.",
        "hey": "Hej",
        "topicStartMessage": "w jakim problemie IT mogę Ci dziś pomóc?",
        "commonItIssues": "Częste problemy IT",
        "newChat": "Nowy czat",
        "open": "Otwórz",
        "close": "Zamknij",
        "recentChats": "Ostatnie czaty",
        "ask": "Zapytaj",
        "internet": "Internet",
        "askEon": "Zapytaj E.ON",
        "askInternet": "Zapytaj Internet",
        "askFollowUpQuestion": "Zadaj pytanie uzupełniające",
        "resolveIssue": "Przesłanie opinii umożliwi działania wsparcia",
        "resolveIssueAfterFeedback": "Przepraszam, nie mogłem rozwiązać Twojego problemu. Jak chciałbyś, abym Ci dalej pomógł?",
        "differentiator": "lub",
        "incident": "Zgłoś zgłoszenie serwisowe",
        "creatingIncident": "Tworzenie incydentu",
        "liveAgent": "Czat z agentem",
        "requestCallbackBtn": "Poproś o oddzwonienie",
        "ticketDescription": "Opis zgłoszenia na podstawie ostatniej dyskusji",
        "createIncident": "Utwórz incydent",
        "confirmCreateIncident": "Potwierdź i utwórz incydent",
        "editCreateIncident": "Edytuj i utwórz incydent",
        "ticketSuccessMsg": "Twój incydent został pomyślnie utworzony, numer zgłoszenia: ",
        "ticketErrorMsg": "Coś poszło nie tak. Spróbuj ponownie później.",
        "chatBotTitle": "Użyj pomocy MyHelp, aby zadać pytanie, uzyskać wsparcie i przydatne informacje z wewnętrznych i zewnętrznych źródeł.",
        "duplicateError": "Powtórzone pytanie, proszę zadać inne pytanie",
        "content": "Treść",
        "tone": "Ton",
        "information": "Informacja",
        "complete": "Zakończ",
        "other": "Inne",
        "irelevantContent": "Nieistotna treść",
        "lackOfDetail": "Brak szczegółów",
        "incorrectInformation": "Niepoprawne informacje",
        "copyLink": "Kopiuj link",
        "openLink": "Otwórz link",
        "internetSearchContent": "Na podstawie zapytaj mnie o wszystko EON gpt",
        "assignmentGroupForTicket": "eon-uk-gsd",
        "copy": "Kopiuj",
        "share": "Udostępnij",
        "copiedMsg": "Pomyślnie skopiowano",
        "copyLinkMsg": "Kopiuj link",
        "sharableLink": "Link do udostępnienia",
        "uploadImage": "Prześlij obraz i zadaj pytanie",
        "liveAgentChat": {
            "connectWithLiveAgent": "Połącz się z Biurem Obsługi",
            "connectingWithLiveAgent": "Łączenie z Biurem Obsługi",
            "connectingHint": "Możesz wrócić do Pomocy, klikając link poniżej pola czatu",
            "agentLeftMsg": "Dziękujemy za kontakt z E.ON",
            "switchToAssistance": "Zakończ czat i przejdź do pomocy",
            "typeMessageHint": "Wpisz swoją wiadomość tutaj...",
            "disconnectingMsg": "Zakończenie czatu i przejście do pomocy",
            "continue": "Kontynuuj",
            "exitChat": "Zakończ czat",
            "chatSessionEndPrompt": "Sesja czatu zakończy się automatycznie za <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "Pomoc MyHelp wykryła, że Twoim domyślnym językiem jest „<language>”. Potwierdź, aby połączyć się z agentem lub zmodyfikuj pożądany język i typ agenta poniżej.",
            "channelsText": "Otrzymaj oddzwonienie przez",
            "languageText": "Język komunikacji",
            "channelLabel": "Wybierz kanał",
            "phoneLabel": "Połącz mnie przez",
            "languageLabel": "Wybierz język",
            "tryAgain": "Spróbuj ponownie",
            "technicalIssue": "Nie można zakończyć oddzwonienia z powodu problemu technicznego. Spróbuj ponownie.",
            "newNumber": "Nowy numer",
            "availableMobileNumbers": "Dostępne numery telefonów komórkowych",
            "chosenNumber": "Połącz mnie na ten numer",
            "phoneError": "Proszę podać prawidłowy numer kontaktowy",
            "referenceNumber": "Numer referencyjny",
            "tooltip": {
                "confirmBtn": "Potwierdź, aby złożyć prośbę o oddzwonienie",
                "resetBtn": "Zresetuj formularz, aby wyczyścić wszystkie wybory i zacząć od nowa",
                "cancelBtn": "Anuluj oddzwonienie"
            },
            "addNewNumber": "nowy numer"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Utwórz zgłoszenie",
                "chatWithServiceDesk": "Rozpocznij czat na żywo",
                "requestCallback": "Poproś o oddzwonienie",
                "ongoingConversation": "Tak, to część mojej ostatniej rozmowy.",
                "newConversation": "Nie. Potrzebuję pomocy w rozwiązaniu nowego problemu",
                "confirmAndCreateTicket": "Potwierdź i utwórz zgłoszenie",
                "cancelTicketCreation": "Anuluj tworzenie zgłoszenia",
                "confirmChatWithServiceDesk": "Potwierdź i połącz się z Biurem Obsługi",
                "cancelChatWithServiceDesk": "Anuluj czat z Biurem Obsługi",
                "cancelRequestCallback": "Anuluj prośbę o oddzwonienie",
                "confirmRequestCallback": "Potwierdzenie połączenia przez <channel> <phone> z agentem my IT support w języku <language>"
            },
            "state": {
                "whatsTheIssue": "Jaki problem chcesz rozwiązać?",
                "lastConversation": "Pewnie, czy problem jest częścią ostatniej rozmowy?",
                "createIncidentLabel": "Zamierzasz zgłosić incydent dla",
                "cancelAck": "Zauważono. Czy mogę pomóc w jakimś innym problemie?",
                "chatWithServiceDeskLabel": "Zamierzasz połączyć się z agentem Biura Obsługi",
                "createTicketLabel": "Potwierdź i utwórz zgłoszenie",
                "cancelTicketLabel": "Anuluj tworzenie zgłoszenia",
                "creatingIncidentTicket": "Tworzenie zgłoszenia incydentu",
                "ticketAttachment": "Proszę dodać zrzut ekranu błędu lub problemu.",
                "ticketAttachmentTooltipInstruction": "Naciśnij klawisz logo Windows + Print screen lub użyj narzędzia snipping tool, aby zrobić zrzut obrazu.",
                "ticketAttachmentTooltipWarning": "Rozmiar obrazu musi być mniejszy niż 5MB",
                "ticketAttachmentLabel": "Załącz zrzut ekranu",
                "ticketAttachmentTitle": "Załączony zrzut ekranu do zgłoszenia",
                "ticketAttachmentError": "Nie można załączyć wybranego pliku. Upewnij się, że wybrany plik jest w formacie jpg, png i ma mniej niż 5MB.",
                "ticketAttachmentErrorAction": "Spróbuj ponownie",
                "ticketDescription": "Opis zgłoszenia",
                "ticketNonITWarning": "Pomoc nie znalazła słów kluczowych, aby zidentyfikować Twój problem jako związany z IT.",
                "ticketNonITWarningQuestion": "Czy chcesz utworzyć incydent z Biurem Obsługi na podstawie Twojej rozmowy o",
                "ticketNonITWarningRecommendationLabel": "Rekomendacja:",
                "ticketNonITWarningRecommendationText": "jeśli masz problem, który nie jest związany z oprogramowaniem lub sprzętem, spróbuj przeformułować swoje wyszukiwanie lub zadać pytanie uzupełniające poniżej",
                "connectWithServiceDeskLabel": "Potwierdź, aby czatować z Biurem Obsługi",
                "requestCallbackLabel": "Poproś o oddzwonienie",
                "requestCallbackInQueuePhone": "Twoja prośba o oddzwonienie została wysłana. Skontaktujemy się z Tobą w ciągu około 5 minut pod numerem <strong><phone></strong>. W tym czasie możesz nadal korzystać z innych aplikacji.",
                "requestCallbackInQueueTeams": "Twoja prośba o oddzwonienie została wysłana. Skontaktujemy się z Tobą w ciągu około 5 minut za pośrednictwem <strong>Microsoft Teams</strong>. W tym czasie możesz nadal korzystać z innych aplikacji.",
                "requestCallbackFailed": "Nie udało się zakończyć oddzwonienia z powodu problemu technicznego. Spróbuj ponownie.",
                "requestCallbackPromptAnswer": "Zamierzasz poprosić o oddzwonienie z my IT support",
                "requestCallbackConfirmLabel": "Potwierdź, aby poprosić o oddzwonienie"
            },
            "tooltips": {
                "createIncident": "Pomaga w rozwiązaniu problemu IT i utworzeniu incydentu z Biurem Obsługi, jeśli to konieczne",
                "chatWithServiceDesk": "Pomaga w rozwiązaniu problemu IT i skontaktowaniu się z Biurem Obsługi przez czat, jeśli to konieczne",
                "requestCallback": "Poproś o oddzwonienie z Biura Obsługi"
            }
        },
        "askTooltip": {
            "eon": "Uzyskaj informacje specyficzne dla firmy z wewnętrznych źródeł",
            "internet": "Uzyskaj informacje z wewnętrznych i zewnętrznych źródeł, takich jak E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "Zobacz w Jira",
            "responseHeading": "Oto podsumowanie Twoich zgłoszeń Jira:",
            "responseSubheading": "Pokazano 15 najlepszych rekordów",
            "noResponse": "Wygląda na to, że nie ma dostępnych zgłoszeń JIRA dla Twojego zapytania w tej chwili.",
            "supportedQuestionMsg": "Hej, przepraszam. Nie do końca zrozumiałem Twoje pytanie. Czy możesz je ponownie przeformułować? Udostępniam kilka przykładowych pytań, aby Ci pomóc:"
        },
        "intune": {
            "selectDevice": "Wybierz urządzenie",
            "changeBrowserHomePage": "Zmień stronę główną przeglądarki",
            "fixWillBeApplied": "Poprawka zostanie zastosowana na tym systemie",
            "confirm": "Potwierdź",
            "fixThis": "Napraw",
            "enterDeviceName": "Wprowadź nazwę urządzenia",
            "selectOrEnterDevice": "Wybierz urządzenie lub wprowadź nazwę swojego urządzenia.",
            "actionFailed": "Akcja nie powiodła się.",
            "working": "Pracuję...",
            "fixOnThis": "Zastosuj na tym urządzeniu",
            "deviceLabel": "Urządzenie",
            "lastActive": "Ostatnia aktywność",
            "today": "Dzisiaj",
            "yesterday": "Wczoraj",
            "daysAgo": "dni temu",
            "deviceTypeLaptop": "Laptop",
            "deviceTypeDesktop": "Komputer stacjonarny",
            "deviceTypeVirtualMachine": "Maszyna wirtualna",
            "deviceTypeUnknown": "Urządzenie",
            "homepageBrowserChange": {
                "syncInstructions": "Zmiana zostanie teraz zastosowana na Twoim urządzeniu. Może to potrwać około 90 minut. Jeśli chcesz przyspieszyć ten proces, możesz uruchomić ręczną synchronizację w Company Portal:\n1. Otwórz Company Portal\n2. W lewym dolnym rogu kliknij Settings obok symbolu koła zębatego.\n3. Następnie kliknij niebieski przycisk \"Synchronize\" i poczekaj na zakończenie synchronizacji.",
                "changeHomepageInstructions": "1. Kliknij trzy kropki (...) w prawym górnym rogu.\n2. Wybierz „Ustawienia”.\n3. W menu po lewej stronie wybierz „Uruchamianie, strona główna i nowe karty”.\n4. W sekcji „Przy uruchamianiu” upewnij się, że opcja „Otwórz wybrane witryny” jest zaznaczona/wybrana.\n5. Następnie kliknij „Dodaj witrynę”.\n6. Wpisz adres strony internetowej, którą chcesz ustawić jako nową stronę główną w Microsoft Edge (na przykład: https://compass.eon.com/).\n7. Kliknij „Dodaj”.\n\nJeśli chcesz usunąć stronę z listy Strona główna, kliknij trzy kropki (...) obok strony, a następnie kliknij „Usuń”.",
                "policyDescription": "Twoja organizacja obecnie zarządza ustawieniami strony głównej przeglądarki za pomocą zasad urządzeń. Aby umożliwić zmianę strony głównej, musimy najpierw ustalić, które urządzenie powinno otrzymać aktualizację zasad.",
                "deviceSelectedForPolicy": "wybrane do odblokowania zasad strony głównej",
                "stepsForEdge": "Kroki, aby zmienić stronę główną w przeglądarce Microsoft Edge",
                "whatsNextTitle": "Co dalej?",
                "whatsNextSubmitted": "Żądanie zezwolenia na dostosowywalną stronę główną zostało wysłane do kolejki zasad urządzenia. ",
                "whatsNextSyncTime": "<strong>90 minut</strong> średni czas synchronizacji potrzebny do odświeżenia zasad w tle. ",
                "whatsNextReturn": "Po 90 minutach wróć do ustawień przeglądarki i wykonaj poniższe kroki. ",
                "homepageEnabled": "Możesz teraz zmienić ustawienia strony głównej przeglądarki. Zwróć uwagę, że zmiana może nie zostać zastosowana natychmiast. Odczekaj około 30 minut, aż synchronizacja zostanie zakończona, a następnie zamknij i ponownie otwórz Edge.",
                "homepageAlreadyEnabled": "Twoje urządzenie ma już włączoną zmianę strony głównej. Przejdź do ustawień przeglądarki i spróbuj ponownie.",
                "homepageEnableFailed": "Nie mogłem włączyć zmiany strony głównej w tej chwili. Spróbuj ponownie później.",
                "homepageRemoved": "Urządzenie zostało usunięte z grupy polityki strony głównej."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Ups! Coś poszło nie tak. Spróbuj ponownie później. Jeśli problem będzie się powtarzał, zgłoś problem z Szybkich Akcji",
            "assistanceTask": "Zadanie Pomocy",
            "myActions": "Moje działania",
            "itReportTitle": "Oto migawka efektywności energetycznej Twojego systemu",
            "days": "Dni",
            "device": "Urządzenie",
            "sinceRestarted": "od ponownego uruchomienia",
            "deviceRestartRecommendation": "Zaleca się natychmiastowe ponowne uruchomienie urządzenia",
            "deviceInCompliance": "Twoje urządzenie jest zgodne",
            "energyConsumed": "Zużycie energii w ciągu ostatnich 7 dni",
            "coEmitted": "Emisja CO2 w ciągu ostatnich 7 dni",
            "cacheActionMsg": "Proszę ponownie uruchomić przeglądarkę, aby zmiany weszły w życie.",
            "diskClean": {
                "primaryBtn": "Tak, wyczyść mój dysk teraz",
                "secondaryBtn": "Nie czyść teraz",
                "successMsg": "Twój dysk został wyczyszczony",
                "successMsgOnList": "Twój dysk został wyczyszczony",
                "failureMsg": "Nie można wyczyścić dysku w tym momencie",
                "progressMsg": "Trwa czyszczenie miejsca",
                "disclaimer": "Proszę zauważyć, że nie dotkniemy Twoich danych osobowych ani służbowych. Podczas gdy czyszczenie odbywa się w tle, możesz korzystać z pomocy.",
                "acknowledgeQuery": "Mogę przeprowadzić oczyszczanie dysku. Podczas oczyszczania dysku usuwane są zbędne pliki, pamięci podręczne i stare dzienniki w systemie. Kliknij przycisk poniżej, aby kontynuować."
            },
            "chromeCache": {
                "primaryBtn": "Tak, wyczyść teraz pamięć podręczną Chrome",
                "secondaryBtn": "Nie czyść teraz pamięci podręcznej Chrome",
                "successMsg": "Twoja pamięć podręczna Chrome została wyczyszczona. Proszę ponownie uruchomić przeglądarkę, aby zmiany weszły w życie.",
                "successMsgOnList": "Twoja pamięć podręczna Chrome została wyczyszczona",
                "failureMsg": "Nie można wyczyścić pamięci podręcznej Chrome w tym momencie",
                "progressMsg": "Trwa czyszczenie pamięci podręcznej Chrome",
                "disclaimer": "Proszę zauważyć, że nie dotkniemy Twoich danych osobowych ani służbowych. Podczas gdy czyszczenie odbywa się w tle, możesz korzystać z pomocy.",
                "acknowledgeQuery": "Mogę pomóc wyczyścić pamięć podręczną przeglądarki. Kliknij przycisk poniżej, aby kontynuować."
            },
            "edgeCache": {
                "primaryBtn": "Tak, wyczyść teraz pamięć podręczną Edge",
                "secondaryBtn": "Nie czyść teraz pamięci podręcznej Edge",
                "successMsg": "Twoja pamięć podręczna Edge została wyczyszczona. Proszę ponownie uruchomić przeglądarkę, aby zmiany weszły w życie.",
                "successMsgOnList": "Twoja pamięć podręczna Edge została wyczyszczona",
                "failureMsg": "Nie można wyczyścić pamięci podręcznej Edge w tym momencie",
                "progressMsg": "Trwa czyszczenie pamięci podręcznej Edge",
                "disclaimer": "Proszę zauważyć, że nie dotkniemy Twoich danych osobowych ani służbowych. Podczas gdy czyszczenie odbywa się w tle, możesz korzystać z pomocy.",
                "acknowledgeQuery": "Mogę pomóc wyczyścić pamięć podręczną przeglądarki. Kliknij przycisk poniżej, aby kontynuować."
            },
            "empowerPlugin": {
                "progressMsg": "Żądanie dotyczące wtyczki Empower jest w toku",
                "successMsgOnList": "Żądanie dotyczące wtyczki Empower zostało zakończone",
                "failureMsg": "Nie udało się zakończyć żądania dotyczącego wtyczki Empower"
            },
            "empowerApp": {
                "primaryBtn": "Tak, proszę naprawić teraz",
                "secondaryBtn": "Nie naprawiaj teraz",
                "successMsg": "Automatyczna naprawa zakończona pomyślnie",
                "successMsgOnList": "Automatyczna naprawa zakończona pomyślnie",
                "failureMsg": "Nie można naprawić wtyczki Empower w tym momencie",
                "progressMsg": "Trwa automatyczna naprawa",
                "disclaimer": "Będziemy ponownie instalować wtyczkę Empower, proszę zamknąć wszystkie aplikacje O365 przed kontynuacją.",
                "acknowledgeQuery": "Mogę pomóc w problemach związanych z dodatkiem Empower. Kliknij poniżej, aby naprawić dodatek Empower."
            },
            "teamsCache": {
                "primaryBtn": "Tak, wyczyść teraz pamięć podręczną Teams",
                "secondaryBtn": "Nie czyść teraz pamięci podręcznej Teams",
                "successMsg": "Twoja pamięć podręczna Teams została wyczyszczona. Możesz otworzyć Teams i ponownie skonfigurować wszelkie ustawienia, które mogły zostać zresetowane.",
                "successMsgOnList": "Twoja pamięć podręczna Teams została wyczyszczona",
                "failureMsg": "Nie można wyczyścić pamięci podręcznej Teams w tym momencie",
                "progressMsg": "Trwa czyszczenie pamięci podręcznej Teams",
                "disclaimer": "Proszę zauważyć, że nie dotkniemy Twoich danych osobowych ani służbowych. Podczas gdy czyszczenie odbywa się w tle, możesz korzystać z pomocy.",
                "acknowledgeQuery": "Mogę pomóc wyczyścić pamięć podręczną Teams. Kliknij przycisk poniżej, aby kontynuować."
            },
            "teamsReinstall": {
                "primaryBtn": "Tak, ponownie zainstaluj Teams",
                "secondaryBtn": "Nie ponownie instaluj Teams",
                "successMsg": "Ponowna instalacja aplikacji Teams została zakończona",
                "successMsgOnList": "Ponowna instalacja aplikacji Teams została zakończona",
                "failureMsg": "Nie można zakończyć ponownej instalacji Teams",
                "progressMsg": "Trwa ponowna instalacja Teams",
                "disclaimer": "Proszę zauważyć, że to jednocześnie pobiera i ponownie instaluje aplikację Teams. To ponownie uruchomi aplikację Teams, proszę zapisać swoją pracę przed kontynuacją.",
                "acknowledgeQuery": "Ponowna instalacja aplikacji Microsoft Teams może rozwiązać problem. Kliknij przycisk poniżej, aby kontynuować."
            },
            "outlookOst": {
                "primaryBtn": "Tak, napraw Outlook",
                "secondaryBtn": "Nie naprawiaj Outlook",
                "successMsg": "Profil Outlook został odtworzony",
                "successMsgOnList": "Profil Outlook został odtworzony",
                "failureMsg": "Nie można odtworzyć profilu Outlook",
                "progressMsg": "Odtwarzanie profilu Outlook",
                "disclaimer": "Wykonanie tej akcji odtworzy lokalnie Twój profil Outlook, co zainicjuje pobieranie e-maili z Exchange, upewnij się, że dostępna jest wystarczająca przepustowość sieci i miejsce na dysku.",
                "acknowledgeQuery": "Może to wynikać z problemów z połączeniem lub nieaktualnych ustawień. Mogę pomóc w diagnostyce i przywróceniu synchronizacji programu Outlook."
            },
            "repairOfficeApps": {
                "primaryBtn": "Tak, napraw aplikacje Office",
                "secondaryBtn": "Nie naprawiaj aplikacji Office",
                "successMsg": "Aplikacje Office zostały naprawione",
                "successMsgOnList": "Aplikacje Office zostały naprawione",
                "failureMsg": "Nie można naprawić aplikacji Office",
                "progressMsg": "Trwa ponowna instalacja aplikacji Office",
                "disclaimer": "Wykonanie tej akcji jednocześnie ponownie zainstaluje aplikacje Office i spróbuje je naprawić, proszę zapisać wszystkie niezapisane prace przed kontynuacją.",
                "acknowledgeQuery": "Może to wynikać z uszkodzonej instalacji lub problemu ze zgodnością. Mogę pomóc naprawić aplikacje Office, aby otwierały się płynnie."
            },
            "intuneSync": {
                "primaryBtn": "Tak, zainicjuj synchronizację Intune",
                "secondaryBtn": "Nie inicjuj synchronizacji",
                "successMsg": "Synchronizacja Intune została zakończona",
                "successMsgOnList": "Synchronizacja Intune została zakończona",
                "failureMsg": "Nie można zainicjować synchronizacji Intune",
                "progressMsg": "Trwa synchronizacja Intune",
                "disclaimer": "Proszę zauważyć, że ta akcja tylko restartuje usługi synchronizacji Intune, nie reinstaluje ani nie naprawia Intune (Portal firmy).",
                "acknowledgeQuery": "Mogę pomóc odświeżyć stan urządzenia i zsynchronizować je z Intune, aby było zgodne, aktualne i stosowało najnowsze zasady."
            },
            "teamsAddin": {
                "primaryBtn": "Tak, włącz dodatek MS Teams",
                "secondaryBtn": "Nie włączaj dodatku",
                "successMsg": "Naprawa dodatku MS Teams została zakończona",
                "successMsgOnList": "Naprawa dodatku MS Teams została zakończona",
                "failureMsg": "Nie można włączyć dodatku MS Teams",
                "progressMsg": "Trwa włączanie dodatku MS Teams",
                "disclaimer": "Proszę zauważyć, że naprawa dodatku MS Teams wymaga ponownego uruchomienia Outlook. Proszę zapisać swoją pracę przed kontynuacją.",
                "acknowledgeQuery": "Mogę pomóc przywrócić dodatek Teams w programie Outlook, aby znów można było planować spotkania. Kliknij przycisk poniżej, aby kontynuować."
            },
            "windowsUpdate": {
                "primaryBtn": "Tak, sprawdź aktualizacje",
                "secondaryBtn": "Nie, nie sprawdzaj",
                "successMsg": "Aktualizacja Windows została uruchomiona",
                "successMsgOnList": "Aktualizacja Windows została uruchomiona",
                "failureMsg": "Nie można uruchomić aktualizacji Windows",
                "progressMsg": "Sprawdzanie aktualizacji",
                "disclaimer": "Ta akcja ma na celu sprawdzenie i pobranie aktualizacji z Microsoft, upewnij się, że jesteś podłączony do odpowiedniej sieci, aby pobrać wszelkie aktualizacje.",
                "acknowledgeQuery": "Mogę pomóc w rozwiązaniu problemów z aktualizacjami systemu Windows i zgodnością na urządzeniu. Kliknij przycisk poniżej, aby kontynuować"
            },
            "smartSolution": {
                "systemName": "Nazwa systemu",
                "primaryBtn": "Uruchom Healthcheck",
                "secondaryBtn": "Nie teraz",
                "askToRunHealthCheck": "Czy chcesz, aby pomoc wykonała szybki test zdrowia?",
                "healthCheckApiRunning": "Analiza i wykonywanie testu zdrowia na",
                "healthCheckApiFail": "Nie udało się pobrać informacji o teście zdrowia, spróbuj ponownie",
                "healthCheckApiSuccess": "Przeanalizowałem system. Następujące problemy nadal występują:",
                "systemCheckMsg": "Trwa kontrola systemu",
                "systemCheckMessages": {
                    "recentlyStarted": "System jest aktualny i niedawno uruchomiony",
                    "appsHealthy": "Wszystkie instalacje aplikacji są zdrowe",
                    "driveSpace": "Dostępna jest wystarczająca ilość wolnego miejsca na dysku systemowym",
                    "noCrashes": "Nie wykryto ostatnio awarii aplikacji"
                },
                "healthCheckNoIssue": "Przeanalizowałem system. <b>Wszystko wydaje się działać poprawnie.</b>",
                "recommendedActionHeading": "Zalecane działania",
                "askForElaboration": "Możesz również rozwinąć konkretny problem lub przesłać zrzut ekranu problemu, z którym się zmagasz.",
                "remindForSystemCheck": "Dobrze, możesz dać mi znać, kiedy chcesz wykonać kontrolę systemu.",
                "recommendedFixesHeading": "Zalecane poprawki",
                "recommendedActionInfo": "Wybierz lub odznacz proponowane poprawki, jeśli to konieczne",
                "noRecommendedAction": "Brak dostępnych zalecanych działań",
                "initiateActionsButton": "Rozpocznij naprawę",
                "selectedActionsProgress": "Wybrane działania są przetwarzane.",
                "selectedActionsProgressNote": "Możesz korzystać z pomocy, podczas gdy działanie jest wykonywane. Twój element działania został dodany do listy zadań pomocy i możesz sprawdzić postęp, zostaniesz powiadomiony po zakończeniu działania.",
                "selectedActionsCompleted": "Wybrane działania zakończone pomyślnie.",
                "selectedActionsFailed": "Wybrane działania nie powiodły się. Sprawdź kartę zadania Pomocy, aby uzyskać szczegóły.",
                "selectedActionsPartiallyCompleted": "Wybrane działania są częściowo zakończone. Sprawdź kartę zadania Pomocy, aby uzyskać szczegóły.",
                "myActionDone": "Oznacz jako zakończone",
                "manualActionDisclaimer": "Ten proces obejmuje zarówno kroki automatyczne, jak i ręczne. Proszę zakończyć działania, gdy zostaniesz o to poproszony",
                "manualActionNotification": "Aby zakończyć naprawę, proszę wykonać dodatkowe kroki ręcznie wymienione w sekcji 'Moje działania'.",
                "deviceSelectionHeading": "Widzę, że używasz wielu systemów. Jeśli chcesz wykonać następujące działanie na innym systemie, wybierz z poniższej listy.",
                "deviceSelectionLabel": "Wybierz system dla działania Nexthink",
                "alerts": {
                    "successTitle": "Zadanie zakończone!",
                    "successMessage": "Wybrane działania zostały zakończone pomyślnie.",
                    "errorTitle": "Zadanie nie powiodło się!",
                    "errorMessage": "Wystąpił błąd podczas przetwarzania wybranego działania.",
                    "partialTitle": "Zadanie zakończone częściowo",
                    "partialMessage": "Wybrane działania są częściowo zakończone. Sprawdź kartę zadania Pomocy, aby uzyskać szczegóły."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "W ciągu ostatnich 7 dni na Twoim urządzeniu wystąpiło <n> przypadków niebieskich ekranów.",
                        "action": "Proszę skontaktować się z GSD w celu uzyskania dalszej pomocy",
                        "actionInfo": "(Brak działania) proszę skontaktować się z GSD w celu uzyskania dalszej pomocy"
                    },
                    "edgeCrashes": {
                        "message": "Znaleźliśmy dowody na <n> awarii przeglądarki Edge w ciągu ostatnich 7 dni. Spróbujemy to naprawić, uruchamiając skrypt na Twoim komputerze.",
                        "action": "Wyczyść pamięć podręczną przeglądarki Edge",
                        "actionInfo": "To wyczyści pamięci podręczne przeglądarki Edge i nie zmodyfikuje plików osobistych"
                    },
                    "chromeCrashes": {
                        "message": "Znaleźliśmy dowody na <n> awarii przeglądarki Chrome w ciągu ostatnich 7 dni. Spróbujemy to naprawić, uruchamiając skrypt na Twoim komputerze.",
                        "action": "Wyczyść pamięć podręczną przeglądarki Chrome",
                        "actionInfo": "To wyczyści pamięć podręczną Chrome, nie zmodyfikuje istniejących plików."
                    },
                    "ZScalarStatus": {
                        "message": "Znaleźliśmy, że usługa Zscaler napotkała kilka problemów na Twoim urządzeniu. Możemy spróbować to naprawić, uruchamiając skrypt na Twoim komputerze.",
                        "action": "Uruchom ponownie usługę Zscaler",
                        "actionInfo": "Ta akcja uruchomi ponownie połączenie sieciowe. Nie ma to wpływu na otwarte programy."
                    },
                    "ZScalarState": {
                        "message": "Znaleźliśmy, że usługa Zscaler napotkała kilka problemów na Twoim urządzeniu. Możemy spróbować to naprawić, uruchamiając skrypt na Twoim komputerze.",
                        "action": "Zresetuj Zscaler",
                        "actionInfo": "Ta akcja uruchomi ponownie połączenie sieciowe. Nie ma to wpływu na otwarte programy."
                    },
                    "driveFreeSpace": {
                        "message": "Twoje urządzenie ma tylko <n> GB wolnego miejsca. Aby zapewnić optymalną wydajność komputera, zalecamy zwiększenie ilości wolnego miejsca dostępnego dla Windows, uruchamiając skrypt na Twoim komputerze.",
                        "action": "Wykonaj czyszczenie dysku",
                        "actionInfo": "Tylko tymczasowe pliki i kosz Twojego urządzenia są czyszczone w tej akcji"
                    },
                    "daysSinceFullBoot": {
                        "message": "Twoje urządzenie nie zostało w pełni ponownie uruchomione w ciągu ostatnich <n> dni. To różni się od normalnej procedury wyłączania. Zalecamy pełne ponowne uruchomienie komputera (Start | Wyłącz | Restart)",
                        "action": "Ponownie uruchom urządzenie w dogodnym dla Ciebie czasie.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "Znaleźliśmy dowody na <n> awarii związanych z Microsoft Teams w ciągu ostatnich 7 dni. Możemy spróbować to naprawić, uruchamiając skrypt do wyczyszczenia pamięci podręcznej Microsoft Teams.",
                        "action": "Uruchom czyszczenie pamięci podręcznej Teams",
                        "actionInfo": "Ta akcja wyczyści pamięć podręczną MS Teams i ponownie uruchomi ją. To może również usunąć wiadomości robocze / nie wysłane w Teams."
                    },
                    "teamsPluginDisabled": {
                        "message": "Wykryliśmy, że Twój dodatek Microsoft Teams w Microsoft Outlook. Powoduje to problemy między tymi dwoma aplikacjami. Możemy spróbować to naprawić, uruchamiając skrypt do ponownej konfiguracji tych ustawień.",
                        "action": "Ustaw dodatki Outlook",
                        "actionInfo": "Ta akcja włącza dodatek Teams w Twoim Outlook i ponownie uruchamia aplikację."
                    },
                    "outlookOstStatus": {
                        "message": "Twój profil Outlook przekroczył optymalny rozmiar, co jest znane z powodowania problemów z Twoją skrzynką pocztową. Możemy spróbować to naprawić, uruchamiając skrypt do odtworzenia tego pliku.",
                        "action": "Napraw plik OST Outlook",
                        "actionInfo": "To zmienia nazwę pliku OST Outlook i ponownie uruchamia aplikację. Usunie to wszelkie robocze e-maile."
                    },
                    "lastOsUpdate": {
                        "message": "Widzimy, że usługa aktualizacji Windows nie działa zgodnie z oczekiwaniami, a Twoja maszyna była ostatnio aktualizowana <n> dni temu. Zalecamy pełne ponowne uruchomienie komputera (Start | Wyłącz | Restart), co pomaga zresetować kilka ustawień.",
                        "action": "Ponownie uruchom urządzenie w dogodnym dla Ciebie czasie",
                        "actionInfo": ""
                    }
                },
                "acknowledgeQuery": "Mogę pomóc w diagnozowaniu problemu z urządzeniem. Sprawdźmy i rozwiążmy ten problem"
            },
            "declineScriptMsg": "Nie chcę uruchamiać skryptu Nexthink, pomóż mi z innym rozwiązaniem",
            "timezone": {
                "primaryBtn": "Tak, kontynuuj",
                "secondaryBtn": "Nie, nie aktualizuj",
                "successMsg": "Wykrywanie strefy czasowej zostało ustawione na automatyczne",
                "successMsgOnList": "Wykrywanie strefy czasowej zostało ustawione na automatyczne",
                "failureMsg": "Nie można zaktualizować konfiguracji strefy czasowej",
                "progressMsg": "Aktualizowanie ustawień strefy czasowej",
                "disclaimer": "Proszę zauważyć, że ta akcja ma na celu ustawienie usługi strefy czasowej na automatyczne, pozwalając systemowi Windows na aktualizację zegara na pulpicie na podstawie wykrytej lokalizacji.",
                "acknowledgeQuery": "Mogę pomóc naprawić ustawienia czasu i strefy czasowej w systemie. Większość problemów związanych z czasem, takich jak dryf zegara, niewłaściwe znaczniki czasu, nieudane kody uwierzytelniające lub niepoprawne godziny spotkań, wynika z nieprawidłowej strefy czasowej lub wyłączonej automatycznej synchronizacji. Kliknij przycisk poniżej, aby automatycznie wykryć i naprawić konfigurację czasu i strefy czasowej w systemie Windows."
            },
            "chooseBrowser": "Wybierz przeglądarkę do wykonania czyszczenia pamięci podręcznej",
            "outlookAutoComplete": {
                "primaryBtn": "Tak, wyczyść pamięć podręczną Outlook",
                "secondaryBtn": "Nie, nie czyść pamięci podręcznej Outlook",
                "successMsg": "Pamięć podręczna autouzupełniania Outlook została wyczyszczona",
                "successMsgOnList": "Pamięć podręczna autouzupełniania Outlook została wyczyszczona",
                "failureMsg": "Nie udało się wyczyścić pamięci podręcznej autouzupełniania Outlook",
                "progressMsg": "Czyszczenie pamięci podręcznej autouzupełniania Outlook",
                "disclaimer": "Pamiętaj, że wyczyszczenie pamięci podręcznej autouzupełniania Outlook spowoduje usunięcie zapisanych podpowiedzi adresów e-mail. Tej operacji nie można cofnąć.",
                "acknowledgeQuery": "Mogę pomóc naprawić pamięć podręczną autouzupełniania programu Outlook. Kliknij przycisk poniżej, aby automatycznie naprawić autouzupełnianie w programie Outlook."
            },
            "restartZscalar": {
                "primaryBtn": "Tak, kontynuuj",
                "secondaryBtn": "Nie, nie uruchamiaj ponownie Zscaler",
                "successMsg": "Zscaler został ponownie uruchomiony",
                "successMsgOnList": "Zscaler został ponownie uruchomiony",
                "failureMsg": "Nie udało się ponownie uruchomić Zscaler",
                "progressMsg": "Ponowne uruchamianie usług Zscaler",
                "disclaimer": "Pamiętaj, że ponowne uruchomienie Zscaler może na krótko rozłączyć Cię z internetem i aplikacjami służbowymi. Zwykle trwa to krócej niż minutę.",
                "acknowledgeQuery": "Mogę pomóc rozwiązać problemy z usługami Zscaler. Kliknij przycisk poniżej, aby naprawić problemy z Zscaler."
            },
            "onedrive": {
                "primaryBtn": "Tak, napraw OneDrive",
                "secondaryBtn": "Nie, nie uruchamiaj naprawy OneDrive",
                "successMsg": "Naprawa OneDrive została zakończona",
                "successMsgOnList": "Naprawa OneDrive została zakończona",
                "failureMsg": "Nie udało się pomyślnie zakończyć operacji naprawy OneDrive",
                "progressMsg": "Trwa naprawa OneDrive",
                "disclaimer": "Należy pamiętać, że naprawa OneDrive spowoduje synchronizację plików lokalnych z chmurą i może potencjalnie przerwać niestandardowe synchronizacje OneDrive.",
                "acknowledgeQuery": "Mogę pomóc rozwiązać problemy z OneDrive. Kliknij przycisk poniżej, aby naprawić problemy z OneDrive."
            },
            "smartcard": {
                "primaryBtn": "Tak, usuń kartę Smartcard",
                "secondaryBtn": "Nie, nie usuwaj karty Smartcard",
                "successMsg": "Microsoft Smartcard została usunięta",
                "successMsgOnList": "Microsoft Smartcard została usunięta",
                "failureMsg": "Nie można usunąć Microsoft Smartcard",
                "progressMsg": "Usuwanie Microsoft Smartcard",
                "disclaimer": "Wykonanie tej operacji może potrwać do 1 minuty.",
                "acknowledgeQuery": "Mogę pomóc rozwiązać problemy z Microsoft Smart Card Reader. Kliknij przycisk poniżej, aby naprawić problemy ze Smart Card."
            },
            "errorFetchingReport": "Przepraszam, nie udało się pobrać raportu. Proszę spróbować ponownie później.",
            "automatedFix": "Automatyczna naprawa",
            "automatedFixConsent": "Mogę rozwiązać ten problem na Twoim urządzeniu. Czy mam uruchomić automatyczną naprawę?",
            "primaryButton": "Tak, uruchom naprawę",
            "teamViewerReset": {
                "primaryBtn": "Tak, kontynuuj",
                "secondaryBtn": "Nie, nie resetuj",
                "successMsg": "Usługi Teamviewer zostały zresetowane",
                "successMsgOnList": "Usługi Teamviewer zostały zresetowane",
                "failureMsg": "Nie można zresetować usług Teamviewer",
                "progressMsg": "Trwa ponowne uruchamianie usług Teamviewer",
                "disclaimer": "Ta czynność zresetuje twoje usługi teamviewer i ponownie uruchomi twoją aplikację teamviewer, upewnij się, że twoja praca została zapisana przed kontynuowaniem",
                "acknowledgeQuery": "Mogę pomóc zresetować Teamviewer. Kliknij przycisk poniżej, aby kontynuować."
            },
            "zoomUninstall": {
                "primaryBtn": "Tak, odinstaluj Zoom",
                "secondaryBtn": "Nie, nie odinstalowuj",
                "successMsg": "Odinstalowano Zoom",
                "successMsgOnList": "Odinstalowano Zoom",
                "failureMsg": "Nie można usunąć Zoom",
                "progressMsg": "Trwa odinstalowywanie Zoom",
                "disclaimer": "Ta operacja odinstaluje Zoom z Twojego urządzenia, a także wyczyści wszystkie konfiguracje Zoom.",
                "acknowledgeQuery": "Mogę pomóc odinstalować Zoom. Kliknij przycisk poniżej, aby kontynuować."
            },
            "webexUninstall": {
                "primaryBtn": "Tak, odinstaluj Webex",
                "secondaryBtn": "Nie, nie odinstalowuj",
                "successMsg": "Odinstalowano Webex",
                "successMsgOnList": "Odinstalowano Webex",
                "failureMsg": "Nie można usunąć Webex",
                "progressMsg": "Trwa odinstalowywanie Webex",
                "disclaimer": "Ta operacja odinstaluje Cisco Webex z Twojego urządzenia, a także wyczyści wszystkie konfiguracje Cisco Webex.",
                "acknowledgeQuery": "Mogę pomóc odinstalować Cisco Webex. Kliknij przycisk poniżej, aby kontynuować."
            },
            "recommendedAction": "Zalecane działanie",
            "noKbArticleFound": "Nie znaleziono żadnych ręcznych kroków ani artykułów bazy wiedzy dotyczących tego problemu. Jednak dostępne jest zalecane działanie, które może go rozwiązać:"
        },
        "sessions": {
            "title": "Ostatnie czaty",
            "clearAll": "Usuń wszystkie czaty",
            "deleteMessage": "Usuń sesję",
            "footer": "Uwaga: Ostatnie rozmowy z 30 dni będą przechowywane.",
            "recentChatTitle": "Historia czatu (30 dni)",
            "noRecentChat": "Brak ostatnich czatów",
            "startNewChat": "Rozpocznij nowy czat",
            "learnMore": "Dowiedz się więcej.",
            "learnMoreTooltip": "Zgodnie z polityką retencji MyHelp, Twoje ostatnie czaty będą dostępne przez 30 dni, chyba że usuniesz ostatnie czaty, używając przycisków usuń lub wyczyść wszystko."
        },
        "search": "E.ON Search",
        "feedbackMsg": "Dziękujemy za Twój Feedback! Doceniamy Twoją pomoc w poprawie naszych usług.",
        "contactNumberPlaceholder": "Numer kontaktowy z kodem kraju",
        "incidentDetailsLabel": "Podsumowanie incydentu",
        "contactNumberLabel": "Proszę podać preferowany numer kontaktowy",
        "incError": "Proszę wprowadzić prawidłowe szczegóły incydentu",
        "contactError": "Proszę wprowadzić prawidłowy numer kontaktowy",
        "searchAsk": "Opisz swój problem, np. reset hasła",
        "teamsInsights": {
            "specifyDateTime": "Czy możesz podać datę i godzinę wystąpienia problemu oraz wskazać konkretną rozmowę lub czat, których to dotyczy?",
            "date": "Data",
            "getMeetings": "Pobierz spotkania",
            "cancel": "Anuluj",
            "noMeetings": "Nie znaleziono spotkań dla wybranej daty.",
            "meetingInstruction": "Wybierz konkretne spotkanie/połączenie, którego dotyczyły problemy z jakością.",
            "identifyIssue": "Zidentyfikuj problem",
            "issueDetectionCompleted": "Wykrywanie problemu zakończone.",
            "detectingIssues": "Wykrywanie problemów ze spotkaniem",
            "recommendedActions": "Zalecane działania:",
            "noInsightsFound": "Nie znaleziono informacji dla wybranego połączenia.",
            "meetingList": "Lista spotkań/połączeń",
            "fetchingMeetings": "Pobieranie wszystkich spotkań Teams na dany dzień",
            "windowsOnly": "Informacje o spotkaniach są dostępne tylko dla połączeń, do których dołączono z urządzeń z systemem Windows.",
            "confirmCreateIncident": "Czy chcesz utworzyć zgłoszenie incydentu dla problemu wykrytego podczas spotkania?",
            "getMeetingsCancelMsg": "Żądanie pobrania spotkań zostało anulowane.",
            "identifyIssueCancelMsg": "Żądanie identyfikacji problemu zostało anulowane.",
            "createIncidentCancelMsg": "Żądanie utworzenia incydentu zostało anulowane.",
            "noIssueFoundInstruction": "Sprawdziliśmy kilka wskaźników wydajności po Twojej stronie i wszystko wygląda dobrze. Jeśli podczas połączenia/spotkania wystąpiły problemy, przyczyna leży zatem najprawdopodobniej po stronie pozostałych uczestników.",
            "report": {
                "lowWifiRootCause": "Sygnał Wi-Fi podczas połączenia był słaby, co mogło spowodować problemy z jakością połączenia. Jeśli łączyłeś się z sieci domowej/zdalnej, sprawdź odległość od routera.",
                "networkIssueRootCauseManaged": "Wygląda na to, że byłeś połączony z biura E.ON i wystąpiły u Ciebie problemy z siecią wpływające na jakość spotkania. Rozważ zgłoszenie incydentu i podanie w nim lokalizacji, w której się znajdowałeś.",
                "networkIssueRootCauseUnmanaged": "Wygląda na to, że nie byłeś połączony z biura E.ON i mogły wystąpić u Ciebie problemy z siecią, które mogły wpłynąć na jakość spotkania. Sprawdź stabilność swojego lokalnego połączenia Wi-Fi lub internetowego. Jeśli to możliwe, użyj połączenia kablowego lub zbliż się do routera Wi-Fi, aby poprawić wydajność sieci.",
                "noDataRootCause": "Brak dostępnych informacji dla tego parametru podczas połączenia.",
                "noIssueRootCause": "Nie wykryto problemu dla tego parametru.",
                "noIssueRecommendation": "Nie jest wymagane żadne działanie.",
                "failed": "Niepowodzenie",
                "checking": "Sprawdzanie",
                "okay": "OK",
                "na": "N/D",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "Użycie CPU urządzenia",
                    "rootCause": "Podczas połączenia wykryliśmy wysokie obciążenie CPU na Twoim urządzeniu. Sprawdź, czy w tle były uruchomione procesy lub aplikacje, i unikaj otwierania zbyt wielu aplikacji podczas połączenia, aby wydajność sprzętowa urządzenia mogła być przeznaczona na spotkanie.",
                    "recommendation": "Zamknij niepotrzebne aplikacje działające w tle podczas połączeń, aby zmniejszyć obciążenie CPU."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Użycie pamięci urządzenia",
                    "rootCause": "Podczas połączenia wykryliśmy wysokie użycie pamięci na Twoim urządzeniu. Sprawdź, czy w tle były uruchomione procesy lub aplikacje, i unikaj otwierania zbyt wielu aplikacji podczas połączenia, aby wydajność sprzętowa urządzenia mogła być przeznaczona na spotkanie.",
                    "recommendation": "Zamknij niepotrzebne aplikacje działające w tle podczas połączeń, aby zmniejszyć użycie pamięci."
                },
                "wifiSignalQuality": {
                    "displayName": "Jakość sygnału Wi-Fi",
                    "recommendation": "Przejdź bliżej routera lub przełącz się na silniejsze źródło sygnału Wi-Fi."
                },
                "audioJitter": {
                    "displayName": "Jitter audio"
                },
                "audioJBDelay": {
                    "displayName": "Opóźnienie bufora jittera audio"
                },
                "audioRecvLossRate": {
                    "displayName": "Współczynnik utraty odbioru audio"
                },
                "audioRtt": {
                    "displayName": "Czas podróży w obie strony audio"
                },
                "videoRtt": {
                    "displayName": "Czas podróży w obie strony wideo"
                },
                "videoRecvLossRate": {
                    "displayName": "Współczynnik utraty odbioru wideo"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "Częstotliwość środkowa kanału Wi-Fi (kHz)",
                    "rootCause": "Używasz połączenia Wi-Fi 2,4 GHz, które często powoduje problemy z jakością połączeń. Rozważ przełączenie na pasmo Wi-Fi 5 GHz lub wyższe.",
                    "recommendation": "Przełącz się na pasmo Wi-Fi 5 GHz (lub wyższe), aby poprawić jakość połączenia."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Wykryto zmianę sieci",
                    "rootCauseManaged": "Wykryliśmy zmiany sieci Wi-Fi lub punktu dostępu podczas Twojego połączenia w biurze E.ON. Mogło to spowodować przerwanie połączenia. Jeśli nie przemieszczałeś się ze swoim urządzeniem, zgłoś to jako incydent.",
                    "rootCauseUnmanaged": "Ustaliliśmy, że nie byłeś połączony z lokalizacji E.ON. Sprawdź, czy Twoje połączenie Wi-Fi jest stabilne, ponieważ problemy z siecią mogą wpłynąć na jakość spotkania."
                }
            }
        },
        "rightSidebar": {
            "panelLabel": "Trwające działania",
            "closePanel": "Zamknij panel działań",
            "openPanel": "Otwórz panel działań",
            "emptyState": "Brak trwających działań.",
            "ticketPrefix": "Zgłoszenie",
            "openedAtPrefix": "Otwarto:",
            "showTicketDetails": "Pokaż podsumowanie zgłoszenia",
            "defaultTaskLabel": "Akcja Nexthink"
        }
    },
    "snow": {
        "welcomeNote": "Poniżej znajdziesz przegląd swoich otwartych zgłoszeń incydentów, swoich żądań i swoich zasobów IT.",
        "tabName": {
            "incidents": "Incydenty",
            "orders": "Zamówienia",
            "itResources": "Zasoby IT",
            "incidentsTable": {
                "noData": "Brak dostępnych danych",
                "btnText": "Otwórz nowy incydent",
                "ongoing": "W toku",
                "closed": "Zamknięte",
                "headlineText": "Incydenty"
            },
            "orderTable": {
                "number": "Numer",
                "catItem": "Pozycja katalogowa",
                "approvalSet": "Zestaw zatwierdzeń",
                "state": "Stan",
                "dueDate": "Termin",
                "createdOn": "Utworzono",
                "noData": "Brak dostępnych danych",
                "btnText": "Zamów usługi IT",
                "headlineText": "Zamówienia",
                "tooltipText": "Zamawiaj i zarządzaj sprzętem IT, oprogramowaniem, licencjami lub usługami"
            },
            "itResourcesTable": {
                "modelCategory": "Kategoria modelu",
                "model": "Model",
                "computerName": "Nazwa komputera",
                "serialNumber": "Numer seryjny",
                "serviceValue1": "Wartość usługi1",
                "serviceValue2": "Wartość usługi2",
                "noData": "Brak dostępnych danych",
                "btnText": "Otwórz zgłoszenie dla zasobów IT",
                "headlineText": "Moje zasoby"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Zakładka",
        "favourite": "Ulubione",
        "categorizeTiles": "Spersonalizowany pulpit",
        "enterTabName": "Wprowadź nazwę zakładki",
        "tabNameError": "Proszę wprowadzić unikalną nazwę zakładki, o długości od 2 do maksymalnie 20 znaków!",
        "tabInputLabel": "Nazwa zakładki",
        "addTabButton": "Dodaj zakładkę",
        "personalizeTab": "Personalizuj zakładki",
        "personalizeTiles": "Personalizuj kafelki",
        "addTab": "Dodaj nową zakładkę",
        "removeTabConfrim": "Czy na pewno chcesz usunąć zakładkę",
        "with": " z",
        "cardIn": "kafelkami?",
        "actionUndone": "Tej akcji nie można cofnąć.",
        "categorizeTilesTitle": "Zmień nazwy zakładek, usuń zakładki i przenieś kafelki w obrębie zakładek",
        "addTabTitle": "Dodaj nową zakładkę. Możesz utworzyć maksymalnie 4 zakładki.",
        "organiseTilesTitle": "Aby przenieść pozycję kafelków"
    },
    "dataTable": {
        "pagingData": "Elementy na stronę",
        "itemString": "elementy",
        "ofString": "z"
    },
    "tourData": {
        "userActions": {
            "back": "Wstecz",
            "close": "Zamknij",
            "last": "Zakończ",
            "next": "Dalej",
            "step": "Krok",
            "of": "z",
            "open": "Otwórz dialog",
            "skip": "Pomiń",
            "start_tour": "Rozpocznij wycieczkę",
            "tour_info": "Czy chcesz, abyśmy pokazali Ci podstawowe funkcje w szybkim przewodniku? Powinno to zająć tylko 1-2 minuty..."
        },
        "tile": {
            "step1": "Użyj MyHelp, aby znaleźć swoje typowe aplikacje robocze lub zadać pytanie dotyczące zasobów E.ON, na przykład IT, swoich projektów, szkoleń, polityk firmy i wielu innych.",
            "step2": "Możesz dowiedzieć się więcej o MyHelp i jego funkcjach, znaleźć odpowiedzi na często zadawane pytania oraz poznać przydatne wskazówki i triki w dokumentacji użytkownika.",
            "step3": "W każdej chwili możesz zmienić preferowany język tutaj.",
            "step4": "Możesz się wylogować, klikając tutaj.",
            "step5": "Rozpocznij nową rozmowę, wywołaj swoje ostatnie czaty, aby kontynuować tam, gdzie skończyłeś, lub rozpocznij wyszukiwanie E.ON, naciskając lupę",
            "step6": "Twój spersonalizowany pulpit pozwala organizować i uzyskiwać dostęp do ulubionych aplikacji roboczych. Wyszukaj aplikację i dodaj ją za pomocą symbolu plus. Twórz nowe zakładki i przestawiaj aplikacje według potrzeb."
        },
        "tab": {
            "step1": "Możesz dodać nową zakładkę, klikając tutaj.",
            "step2": "Kliknij tutaj, aby zorganizować kolejność kafelków.",
            "step3": "Tutaj możesz zmieniać nazwy i organizować zakładki."
        },
        "chat": {
            "step1": "Opisz swój problem IT",
            "step1_description": "Otrzymaj instrukcje krok po kroku dotyczące typowych problemów IT – na podstawie baz wiedzy wsparcia IT E.ON. W razie potrzeby MyHelp skieruje Cię również do odpowiedniego kanału wsparcia IT.",
            "step2": "Poznaj typowe zagadnienia IT",
            "step2_description": "Te przykłady pokazują często spotykane zagadnienia IT, w których MyHelp może Cię wspierać krok po kroku.",
            "navigation": "Poruszaj się po MyHelp",
            "headerNavigation_description": "Użyj nawigacji w nagłówku, aby otworzyć Ask MyHelp, Dashboard i inne dostępne strony.",
            "sidebarNavigation_description": "Użyj menu bocznego, aby otwierać strony, rozpocząć nowy czat lub wrócić do ostatnich rozmów.",
            "support_description": "Otwórz My IT-Support, aby uzyskać pomoc z problemem IT i znaleźć odpowiednią opcję wsparcia.",
            "step3": "Uzyskaj szybszy dostęp do swoich aplikacji",
            "step3_description": "Użyj pulpitu nawigacyjnego, aby zapisać często używane aplikacje i utworzyć swój osobisty obszar roboczy.",
            "step4": "Rozpocznij nowy czat lub kontynuuj wcześniejsze rozmowy",
            "step4_description": "Skorzystaj z paska bocznego, aby rozpocząć nową rozmowę lub szybko wrócić do wcześniejszych czatów."
        }
    },
    "allApps": {
        "addAppsBtn": "Dodaj aplikacje",
        "addAppsInfo": "Kliknij Dodaj aplikacje, aby rozpocząć",
        "addAppsTitle": "Stwórz swoją spersonalizowaną przestrzeń roboczą",
        "addAppsDesc": "Dodaj najczęściej używane aplikacje, aby szybciej uzyskiwać dostęp do narzędzi, z których korzystasz każdego dnia",
        "customTileButton": "Dodaj niestandardowy kafelek",
        "CustomTileHeading": "Niestandardowy kafelek",
        "customTileTitleLabel": "Tytuł kafelka",
        "customTileSubTitle": "Opis kafelka",
        "customTileUrlLabel": "Link do kafelka",
        "createCardBtn": "Utwórz kafelek",
        "modalHeading": "Aplikacje na E.ON",
        "modalDesc": "Wyszukaj lub wybierz aplikację, aby dodać ją do strony głównej",
        "titleRequired": "Tytuł kafelka jest wymagany",
        "linkRequired": "Link do kafelka jest wymagany",
        "searchPlaceholder": "Wyszukaj aplikację"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Portal wdrożeniowy",
        "heading": "Portal onboardingu",
        "subHeading": "Przejrzyj swoją aplikację, dodaj nowe i udostępnij dostęp do zarządzania swojemu zespołowi.",
        "modules": {
            "home": "Strona główna",
            "apps": "Aplikacje",
            "appsLabel": "Aplikacje",
            "qna": "Q&A",
            "qnaLabel": "Pytanie i odpowiedź",
            "review": "Przegląd",
            "reviewLabel": "Przegląd",
            "onboardApp": "Dodaj nową aplikację",
            "manageApp": "Zarządzaj aplikacjami",
            "defaultApps": "Aplikacje domyślne",
            "onboardQnA": "Dodaj QnA",
            "manageQnA": "Zarządzaj QnA",
            "reviewDashboard": "Panel recenzenta",
            "reviewApps": "Przejrzyj aplikacje",
            "reviewQnA": "Przejrzyj Q&A"
        },
        "appOnboardingForm": {
            "formHeading": "Dodaj nową aplikację",
            "successAlert": "Aplikacja została pomyślnie dodana!",
            "appTitleLabel": "Tytuł aplikacji",
            "appTitleTooltip": "Nazwa aplikacji do wyświetlenia",
            "appTitlePlaceholder": "Nazwa aplikacji do wyświetlenia",
            "appTitleError": "Tytuł aplikacji jest wymagany",
            "appSubTitleLabel": "Podtytuł aplikacji",
            "appSubTitleTooltip": "Podtytuł aplikacji",
            "appSubTitlePlaceholder": "Podtytuł aplikacji",
            "appSubTitleError": "Podtytuł aplikacji jest wymagany",
            "appUrlLabel": "URL aplikacji",
            "appUrlTooltip": "Docelowy adres URL aplikacji",
            "appUrlPlaceholder": "Docelowy adres URL aplikacji",
            "appUrlError": "URL aplikacji jest wymagany",
            "appKeywordsLabel": "synKeywords (oddzielone przecinkami)",
            "appKeywordsTooltip": "Wpisz synonimy, których użytkownicy mogą użyć, aby znaleźć aplikację i oddziel je przecinkiem",
            "appKeywordsPlaceholder": "Wpisz synonimy, których użytkownicy mogą użyć, aby znaleźć aplikację i oddziel je przecinkiem",
            "appKeywordsError": "Słowa kluczowe są wymagane",
            "appCompaniesAllowedLabel": "Dozwolone firmy",
            "appCompaniesAllowedTooltip": "Lista wszystkich firm, gdzie ta aplikacja jest dozwolona. Jeśli dozwolona dla wszystkich, pozostaw puste.",
            "appCompaniesAllowedInfoMessage": "Lista wszystkich firm, gdzie ta aplikacja jest dozwolona. Jeśli dozwolona dla wszystkich, pozostaw puste.",
            "appCompaniesAllowedOtherLabel": "Inne dozwolone firmy",
            "appCompaniesAllowedOtherPlaceholder": "Podaj inne dozwolone firmy",
            "appCompaniesRestrictedLabel": "Ograniczone firmy",
            "appCompaniesRestrictedTooltip": "Lista wszystkich firm, gdzie ta aplikacja NIE jest dozwolona. Jeśli brak ograniczeń, pozostaw puste.",
            "appCompaniesRestrictedInfoMessage": "Lista wszystkich firm, gdzie ta aplikacja NIE jest dozwolona. Jeśli brak ograniczeń, pozostaw puste.",
            "appCompaniesRestrictedOtherLabel": "Inne ograniczone firmy",
            "appCompaniesRestrictedOtherPlaceholder": "Podaj inne ograniczone firmy",
            "appTooltipLabel": "Podpowiedź (podaj wszystkie języki, jeśli mają być wyświetlane różne nazwy)",
            "appTooltipTooltip": "Podaj wszystkie języki, jeśli mają być wyświetlane różne nazwy, np. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Podaj wszystkie języki, jeśli mają być wyświetlane różne nazwy, np. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Podpowiedź jest wymagana",
            "appIconLabel": "Prześlij ikonę aplikacji",
            "appIconTooltip": "Prześlij ikonę aplikacji",
            "previewAppBtn": "Podgląd aplikacji",
            "cancelBtn": "Anuluj",
            "closeBtn": "Zamknij",
            "submitAppBtn": "Prześlij aplikację",
            "updateAppBtn": "Aktualizuj aplikację",
            "editAppBtn": "Edytuj aplikację",
            "appTitlePreview": "Tytuł",
            "appSubTitlePreview": "Podtytuł",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Słowa kluczowe",
            "appCompaniesAllowedPreview": "Dozwolone firmy",
            "appCompaniesRestrictedPreview": "Ograniczone firmy",
            "appTooltipPreview": "Podpowiedź",
            "message": "Po przesłaniu aplikacji otrzymuje ona status Oczekujące i przechodzi przez zdefiniowany cykl życia przeglądu — postępując od Oczekujące → Zatwierdzone (w trakcie przeglądu/testowania) → W QA (formalnie zatwierdzone i weryfikowane) → W produkcji (na żywo i widoczne dla użytkowników końcowych w MyHelp), lub może zostać Odrzucone, jeśli nie spełnia kryteriów; w takim przypadku interesariusz może edytować i ponownie przesłać."
        },
        "qnaOnboardingForm": {
            "formHeading": "Dodaj nowe QnA",
            "successAlert": "QnA zostało pomyślnie dodane!",
            "qnaQuestionLabel": "Pytanie",
            "qnaQuestionTooltip": "Wprowadź pytanie dla elementu QnA",
            "qnaQuestionPlaceholder": "Wprowadź pytanie",
            "qnaQuestionError": "Pytanie jest wymagane",
            "qnaAnswerLabel": "Odpowiedź",
            "qnaAnswerTooltip": "Wprowadź odpowiedź dla elementu QnA",
            "qnaAnswerPlaceholder": "Wprowadź odpowiedź na pytanie",
            "qnaAnswerError": "Odpowiedź jest wymagana",
            "qnaCategoryLabel": "Kategoria",
            "qnaCategoryTooltip": "Wybierz kategorię dla elementu QnA",
            "qnaCategoryPlaceholder": "Wybierz kategorię dla elementu QnA",
            "qnaCategoryError": "Kategoria jest wymagana",
            "qnaCategoryOtherLabel": "Inna kategoria",
            "qnaCategoryOtherPlaceholder": "Wprowadź własną kategorię",
            "qnaCompaniesAllowedLabel": "Dozwolone firmy",
            "qnaCompaniesAllowedTooltip": "Lista wszystkich firm, gdzie ta aplikacja jest dozwolona. Jeśli dozwolona dla wszystkich, pozostaw puste.",
            "qnaCompaniesAllowedInfoMessage": "Lista wszystkich firm, gdzie ta aplikacja jest dozwolona. Jeśli dozwolona dla wszystkich, pozostaw puste.",
            "qnaCompaniesAllowedOtherLabel": "Inne dozwolone firmy",
            "qnaCompaniesAllowedOtherPlaceholder": "Podaj inne dozwolone firmy",
            "qnaCompaniesRestrictedLabel": "Ograniczone firmy",
            "qnaCompaniesRestrictedTooltip": "Lista wszystkich firm, gdzie ta aplikacja NIE jest dozwolona. Jeśli brak ograniczeń, pozostaw puste.",
            "qnaCompaniesRestrictedInfoMessage": "Lista wszystkich firm, gdzie ta aplikacja NIE jest dozwolona. Jeśli brak ograniczeń, pozostaw puste.",
            "qnaCompaniesRestrictedOtherLabel": "Inne ograniczone firmy",
            "qnaCompaniesRestrictedOtherPlaceholder": "Podaj inne ograniczone firmy",
            "previewQnABtn": "Podgląd QnA",
            "cancelBtn": "Anuluj",
            "submitQnABtn": "Prześlij QnA",
            "updateQnABtn": "Aktualizuj QnA",
            "editQnABtn": "Edytuj QnA",
            "addNewQnABtn": "+ Dodaj QnA",
            "qnaQuestionPreview": "Pytanie",
            "qnaAnswerPreview": "Odpowiedź",
            "qnaCompaniesAllowedPreview": "Dozwolone firmy",
            "qnaCompaniesRestrictedPreview": "Ograniczone firmy",
            "message": "Po przesłaniu wpisu Q&A otrzymuje on status Oczekujące i przechodzi przez zdefiniowany cykl życia przeglądu — postępując od Oczekujące → Zatwierdzone (w trakcie przeglądu/testowania) → W QA (formalnie zatwierdzone i weryfikowane) → W produkcji (na żywo i widoczne dla użytkowników końcowych w MyHelp), lub może zostać Odrzucone, jeśli nie spełnia kryteriów; w takim przypadku interesariusz może edytować i ponownie przesłać."
        },
        "manageBtn": "Zarządzaj",
        "refreshBtn": "Odśwież",
        "exportBtn": "Eksportuj",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Eksportuj aplikacje jako CSV",
        "exportAppsExcelBtn": "Eksportuj aplikacje jako Excel",
        "exportQnACsvBtn": "Eksportuj QnA jako CSV",
        "exportQnAExcelBtn": "Eksportuj QnA jako Excel",
        "approveBtn": "Zatwierdź",
        "rejectBtn": "Odrzuć",
        "toQABtn": "Przenieś do QA",
        "toProdBtn": "Przenieś do produkcji",
        "editBtn": "Edytuj",
        "viewBtn": "Zobacz",
        "closeBtn": "Zamknij",
        "dashboard": {
            "appsTitle": "Dostępne aplikacje",
            "appsText": "Aplikacje dostępne dla Ciebie dzięki własności lub udostępnianiu zespołowemu.",
            "qnaTitle": "Pytania i odpowiedzi",
            "qnaText": "Pytania i odpowiedzi dostępne dla Ciebie dzięki własności lub udostępnianiu zespołowemu."
        },
        "modalLabel": {
            "reviewAppTitle": "Sprawdź aplikację do wdrożenia",
            "reviewQnATitle": "Sprawdź Q&A do wdrożenia",
            "owner": "Właściciel",
            "createdOn": "Utworzono",
            "status": "Status",
            "url": "URL",
            "tooltip": "Podpowiedź",
            "companiesAllowed": "Dozwolone firmy",
            "companiesRestricted": "Ograniczone firmy",
            "keywords": "Słowa kluczowe",
            "reviewerComments": "Komentarze recenzji",
            "category": "Kategoria",
            "question": "Pytanie",
            "answer": "Odpowiedź",
            "mail": "E-mail"
        },
        "statusLabel": {
            "pending": "Oczekujący",
            "approved": "Zatwierdzony",
            "rejected": "Odrzucony",
            "onhold": "Wstrzymany",
            "unknown": "Nieznany",
            "all": "Wszystkie",
            "inQA": "W QA",
            "inProd": "W produkcji"
        },
        "activityLabel": {
            "allowed": "Dozwolone",
            "restricted": "Ograniczone"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Akcja",
            "icon": "Ikona",
            "title": "Tytuł",
            "subTitle": "Podtytuł",
            "question": "Pytanie",
            "answer": "Odpowiedź",
            "category": "Kategoria",
            "owner": "Właściciel",
            "description": "Opis",
            "apps": "Aplikacje",
            "qna": "Pytanie i odpowiedź",
            "defaultApps": "Aplikacje domyślne",
            "defaultAppsActivity": "Zmiany w aplikacjach domyślnych",
            "search": "Szukaj",
            "selectCompany": "Wybierz firmę",
            "otherCompany": "Nazwa innej firmy",
            "selectAll": "Zaznacz wszystko",
            "company": "Firma",
            "update": "Aktualizuj",
            "comments": "Komentarze"
        },
        "noData": {
            "dashboardEmpty": "Nie dodano żadnych aplikacji ani Q&A",
            "dashboardAppsEmpty": "Nie dodano żadnych aplikacji",
            "dashboardQnAEmpty": "Nie dodano żadnych Q&A",
            "reviewDashboardEmpty": "Nie przesłano żadnych aplikacji ani Q&A do przeglądu.",
            "reviewAppsEmpty": "Nie przesłano żadnych aplikacji do przeglądu.",
            "reviewQnAEmpty": "Nie przesłano żadnych Q&A do przeglądu."
        },
        "manageApp": {
            "heading": "Zarządzaj aplikacjami",
            "subHeading": "Wyświetlane są tylko aplikacje, których jesteś właścicielem lub do których przyznano Ci dostęp."
        },
        "manageQnA": {
            "heading": "Zarządzaj QnA",
            "subHeading": "Wyświetlane są tylko QnA, których jesteś właścicielem lub do których przyznano Ci dostęp."
        },
        "defaultApps": {
            "heading": "Aplikacje domyślne",
            "subHeading": "To są domyślne aplikacje dostępne dla wszystkich użytkowników. Możesz poprosić o dołączenie nowych aplikacji lub poprosić o dostęp do zarządzania istniejącymi aplikacjami z sekcji Zarządzaj aplikacjami.",
            "searchPlaceholder": "Szukaj aplikacji"
        },
        "reviewDashboard": {
            "heading": "Panel przeglądu",
            "subHeading": "Przeglądaj oczekujące wnioski onboardingowe aplikacji oraz zatwierdzaj je lub odrzucaj. Twoje terminowe przeglądy pomagają nam utrzymać trafny i przydatny zbiór aplikacji dla wszystkich."
        },
        "reviewApps": {
            "heading": "Przegląd aplikacji",
            "subHeading": "Przeglądaj oczekujące wnioski onboardingowe aplikacji oraz zatwierdzaj je lub odrzucaj. Twoje terminowe przeglądy pomagają nam utrzymać trafny i przydatny zbiór aplikacji dla wszystkich."
        },
        "reviewQnA": {
            "heading": "Przegląd Q&A",
            "subHeading": "Przeglądaj oczekujące wnioski onboardingowe QnA oraz zatwierdzaj je lub odrzucaj. Twoje terminowe przeglądy pomagają nam utrzymać trafny i przydatny zbiór QnA dla wszystkich."
        },
        "reviewQueue": {
            "heading": "Kolejka przeglądu",
            "subHeading": "Przejrzyj i zatwierdź lub odrzuć oczekujące żądania dołączenia aplikacji. Twoje szybkie przeglądy pomagają nam utrzymać trafną i przydatną kolekcję aplikacji dla wszystkich."
        },
        "activityLog": {
            "heading": "Dziennik aktywności"
        },
        "quickActions": {
            "title": "Szybkie akcje",
            "onboardNewApp": "Dodaj nową aplikację",
            "manageApps": "Zarządzaj aplikacjami",
            "defaultApps": "Aplikacje domyślne",
            "onboardNewQnA": "Dodaj nowe pytanie i odpowiedź",
            "manageQnA": "Zarządzaj pytaniami i odpowiedziami",
            "reviewerDashboard": "Panel recenzenta",
            "reviewApps": "Przejrzyj wdrożone aplikacje",
            "reviewQnA": "Przejrzyj wdrożone Q&A"
        }
    },
    "sourceSelector": {
        "title": "Wybierz źródło",
        "allSources": "Wszystkie źródła",
        "allSourcesDesc": "Szukaj we wszystkich wewnętrznych źródłach informacji E.ON",
        "eonKnowledgeBase": "E.ON Baza wiedzy",
        "eonKnowledgeBaseDesc": "Dostęp do ogólnej wiedzy firmowej",
        "eonMyItOrder": "E.ON Moje zamówienia IT",
        "eonMyItOrderDesc": "Zarządzaj i śledź zamówienia usług IT",
        "eonItKnowledgeBase": "E.ON Baza wiedzy IT",
        "eonItKnowledgeBaseDesc": "Znajdź informacje i rozwiązania związane z IT",
        "myGenius": "My Genius",
        "myGeniusDesc": "Odkrywaj wewnętrzne kursy i materiały edukacyjne",
        "confluenceAll": "Confluence (Wszystkie)",
        "confluenceAllDesc": "Przeszukuj dokumentację współpracującą",
        "sharepointAll": "SharePoint (Wszystkie)",
        "sharepointAllDesc": "Przeszukuj wspólne pliki i zasoby",
        "eonApps": "E.ON Aplikacje",
        "eonAppsDesc": "Odkrywaj i korzystaj z aplikacji firmowych",
        "hrPolicies": "Polityki HR",
        "hrPoliciesDesc": "Dostęp do polityk i przewodników HR",
        "compass": "Compass",
        "compassDesc": "Odkrywaj intranet E.ON",
        "back": "Powrót",
        "search": "Szukaj...",
        "noMatches": "Brak wyników"
    },
    "ailoader": {
        "thinking": "Myślenie",
        "reading": "Czytanie źródeł",
        "processing": "Przetwarzanie",
        "analysing": "Analizowanie wyników",
        "preparing": "Przygotowywanie odpowiedzi",
        "working": "Pracuję nad Twoją odpowiedzią – może to potrwać chwilę."
    },
    "compassScopeSelector": {
        "title": "Wybierz jednostkę biznesową",
        "iconLabel": "Zakres wyszukiwania",
        "localSearch": "Wyszukiwanie lokalne",
        "compassWideSearch": "Wyszukiwanie w całym Compass",
        "resetToCompassWide": "Resetuj do wyszukiwania w całym Compass",
        "switchToLocal": "Przełącz na wyszukiwanie lokalne",
        "localDescription": "Wyszukaj w swojej firmie i publicznych postach",
        "compassWideDescription": "Wyszukaj we wszystkich jednostkach biznesowych"
    },
    "errorMessages": {
        "azureAiContentViolation": "Odpowiedź została przefiltrowana z powodu uruchomienia polityki zarządzania treścią Azure OpenAI przez zapytanie. Proszę zmodyfikować zapytanie i spróbować ponownie."
    }
}